<script>
import vue2Dropzone from "vue2-dropzone";
import Vue from "vue";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import firebase from "firebase/compat/app";
import { functions } from "../main";
import "firebase/firestore";
import "firebase/functions";
import Profile from "../components/Profile/Profile.vue";
import DeclineBookingDialog from "../components/declineBookingDialog.vue";
import RatingDialog from "../components/RatingDialog.vue";
import ItemQualityDialog from "../components/ItemQualityDialog.vue";
import RatingItemDialog from "../components/RatingItemDialog.vue";
import LoginComponent from "@/components/Auth/Login";
import SignupComponent from "@/components/Auth/Signup";
import RatingItemDashPop from "@/components/rating/rateItemDashPop.vue";
import { getDocs, collection, query, getFirestore } from "firebase/firestore";
import { mapState } from "vuex"; //

new Vue({
  beforeCreate: function () {
    // console.log('dash state: ', this.$dashState);
  },
});

const uuid = require("uuid");

export default {
  name: "Dashboard",
  metaInfo: {
    title: "Dashboard",
    titleTemplate: "Strapp - Dashboard 📊",
    content:
      "An online rental marketplace where you can rent out your household items and equipment to others for short term periods.",
    htmlAttrs: { lang: "en" },
    meta: [
      { charset: "utf-8" },
      { name: "viewport", content: "width=device-width, initial-scale=1" },
    ],
  },

  //payment prop
  props: {
    paymentSuccess: {
      type: String,
      default: "false",
    },
    // verificationSuccess: {
    //   type: String,
    //   default: false,
    // },
    // tab_state: {
    //   type: Object,
    //   required: true,
    //   default: 'listings',
    // },
  },

  data() {
    return {
      placedView: "all",
      recievedView: "all",
      placedBookingStates: [
        "all",
        "pending",
        "awaiting-payment",
        "finalised",
        "active",
      ],
      receivedBookingStates: [
        "all",
        "pending",
        "awaiting-payment",
        "finalised",
        "active",
      ],
      receivedTableSwitch: false,
      placedTableSwtich: false,
      userType: "",
      supportType: "",
      openSupportDialog: true,
      tabState: this.tab_state,
      reviewState: "user",
      bookingState: "pending",
      returnedState: "past-borrowed",
      dropzoneOptions: {
        url: "https://httpbin.org/post",
        thumbnailWidth: 200,
        // maxFilesize: 0.5,
        addRemoveLinks: true,
        dictDefaultMessage: `<p class='text-default'><i class='fa fa-cloud-upload mr-2'></i> Drag Images or Click Here</p>
          `,
        headers: { "My-Awesome-Header": "header value" },
      },
      rating: 0,
      review: "",
      max: 500,
      rateSuccessDialog: false,
      booking: {},
      state1: "",
      dialog: false,
      dialog1: false,
      itemQualityDialog: false,
      rateUserDialog: false,
      rateItemDialog: false,
      show1: false,
      // refreshKey: false,
      show2: false,
      editPdialog: false,
      acceptedDialog: false,
      returnedDialog: false,
      fab: false,
      snackbar: false,
      text: ``,
      stateData: "",
      photo: "",
      userId: "",
      name: "",
      loadedItems: [],
      loadedUserBookings: [],
      email: "",
      loginDialog: false,
      rateSuccessDialog: false,
      signupDialog: false,
      editedEmail: "",
      password: "",
      verified: false,
      confirmPassword: "",
      recievedPendingMenu: false,
      refreshDialog: false,
      cards: ["Today", "Yesterday"],
      tab: "listings",
      rules: {
        required: (value) => !!value || "Required.",
        min: (v) => v.length >= 8 || "Min 8 characters",
        emailMatch: () => "The email and password you entered don't match",
      },
    };
  },

  components: {
    Profile,
    LoginComponent,
    SignupComponent,
    Loader: () => import("@/components/Loader.vue"),
    LinkPayVerify: () => import("@/components/LinkPayVerify.vue"),
    vueDropzone: vue2Dropzone,
    DeclineBookingDialog,
    RatingDialog,
    ItemQualityDialog,
    RatingItemDialog,
    RatingItemDashPop,
    BookingsPlacedTable: () =>
      import("@/components/dashboard/BookingsPlacedTable.vue"),
    BookingsReceivedTable: () =>
      import("@/components/dashboard/BookingsReceivedTable.vue"),
    DashLoader: () => import("@/components/dashboard/DashLoader.vue"),
  },

  async created() {
    //  await this.$store.dispatch('loadBookings');

    console.log("tab param", this.$route.query.s);
    const tab = this.$route.query.s;

    if (tab == 1) {
      this.changeState("listings");
    } else if (tab == 2) {
      this.changeState("bookings-received");
    } else if (tab == 3) {
      this.changeState("bookings-placed");
    } else {
      this.changeState("bookings-placed");
    }

    // this.$store.dispatch("loadUserBookings", this.$store.getters.user.id);

    firebase.auth().onAuthStateChanged((user) => {
      this.authUser = user;
      if (user) {
        this.displayName = user.displayName;
        if (this.photoURL) {
          this.photoURL = user.photoURL;
        }
        this.email = user.email;
        this.userId = user.uid;
      } else {
        this.loginDialog = true;
      }
      this.$store.dispatch("loadUserBookings", this.userId);
    });
    // console.log('created state: ', this.stateData);
    // console.log('s: ', this.s);

    Vue.prototype.$dashState = "listedItems";
  },

  // updated() {
  //   if ((this.paymentSuccess = true)) {
  //     this.paymentSuccessDialog = true;
  //   }
  // },

  async mounted() {
    // console.log('user id', this.userId);
    // console.log('mounted state: ', await this.$store.getters. loadedUserBookings);

    // Call the method to check and redirect to onboarding if needed
    this.redirectToOnboarding();

    if (this.$store.getters.loadedUserBookings == undefined) {
      console.log("HEllo sirrr?");
      // this.delay(2).then(() => {
      this.$store.commit("setLoading", true);

      this.refreshDialog = true;
      // });

      // this.reload();
    }

    // console.log('payment Success mounted', this.paymentSuccess);
    if (this.paymentSuccess == "true") {
      this.paymentSuccessDialog = true;
    }

    // this.stateData = this.$route.params;
    // console.log('state is', this.$route.query.s);
    // this.state1 = this.$route.query.s;
    // if (this.state1 != undefined) {
    //   this.state1 = String(Number(this.state1) + 1);
    //   console.log('new state', this.state1);
    // } else {
    //   this.state1 = '1';
    // }

    //  await this.getAllowedDates();
    // this.getDates()
  },

  watch: {
    tab_state: function () {
      this.tabState = this.tab_state;
    },
    // Watch for changes to the 'onboarded' state
    onboarded: {
      // immediate: true, // Trigger the watcher immediately when the component is created
      handler(newValue) {
        console.log("onboarded", newValue);
        // Redirect the user to the onboarding page if 'onboarded' is false
        if (newValue === false) {
          this.$router.push("/onboarding");
        }
      },
    },
    $route() {
      this.loadParam();
    },
  },

  computed: {
    ...mapState(["onboarded"]), // Map the 'onboarded' state to the component's computed properties

    Onboarded() {
      return this.$store.getters.user.onboarded;
    },
    // paymentSuccess() {
    //   return this.$store.getters.paymentSuccess;
    // },

    user() {
      return this.$store.state.user;
    },

    firstName() {
      return this.$store.getters.user.firstName;
    },

    reviews() {
      // console.log('all reviews: ', this.$store.getters.loadedReviews);
      return this.$store.getters.loadedReviews.filter(
        (review) =>
          review.borrowerID === this.userId && review.reviewType === "user"
      );
    },

    itemReviews() {
      // console.log('all reviews: ', this.$store.getters.loadedReviews);
      return this.$store.getters.loadedReviews.filter(
        (review) =>
          review.lenderID === this.userId && review.reviewType === "item"
      );
    },

    reviewAvg() {
      let sum = 0;
      let count = 0;
      this.reviews.forEach((review) => {
        sum += review.rating;
        count++;
      });
      // if (reviews.length === 0){
      //   this.reviewState = 'item'
      // }
      if (sum === 0) {
        return 0;
      } else {
        return Math.round((sum / count) * 100) / 100;
      }
    },

    itemReviewAvg() {
      let sum1 = 0;
      let count1 = 0;
      this.items.forEach((item) => {
        if (item.rating != undefined) {
          sum1 += item.rating * item.rating_count;
          count1 = count1 + Number(item.rating_count);
        }
      });
      console.log(sum1, count1);
      if (sum1 === 0) {
        return 0;
      } else {
        return Math.round((sum1 / count1) * 100) / 100;
      }
    },

    size() {
      const size = { xs: "small", sm: "medium", lg: "medium", xl: "medium" }[
        this.$vuetify.breakpoint.name
      ];
      return size ? { [size]: true } : {};
    },

    loading() {
      return this.$store.getters.loading;
    },

    items() {
      return this.$store.getters.loadedItems.filter((item) => {
        return item.userID === this.userId;
      });
    },
    reviewSubmitted() {
      return this.$store.getters.reviewSuccess;
    },
    returned() {
      // console.log('returned', this.$store.getters.loadedUserBookings);

      return this.$store.getters.loadedUserBookings.filter((booking) => {
        return (
          ((booking.lenderID === this.userId ||
            booking.borrowerID === this.userId) &&
            booking.status === "complete") ||
          ((booking.lenderID === this.userId ||
            booking.borrowerID === this.userId) &&
            booking.status === "returnedL") ||
          booking.status === "returnedB" ||
          (booking.status === "returned" &&
            (booking.lenderID === this.userId ||
              booking.borrowerID === this.userId)) ||
          (booking.status === "awaiting-deposit" &&
            (booking.borrowerID === this.userId ||
              booking.lenderID === this.userId))
        );
      });
    },

    bookingsPlacedReturned() {
      return this.$store.getters.loadedUserBookings.filter((booking) => {
        return (
          (booking.borrowerID === this.userId &&
            booking.status === "returned") ||
          (booking.borrowerID === this.userId && booking.status === "returnedL")
        );
      });
    },

    bookingsReceivedReturned() {
      return this.$store.getters.loadedUserBookings.filter((booking) => {
        return (
          (booking.lenderID === this.userId && booking.status === "returned") ||
          (booking.lenderID === this.userId && booking.status === "returnedB")
        );
      });
    },

    bookingsReceivedPendingReturn() {
      return this.$store.getters.loadedUserBookings.filter((booking) => {
        return (
          booking.lenderID === this.userId &&
          booking.status === "pending-return"
        );
      });
    },

    bookingsPlacedPendingReturn() {
      return this.$store.getters.loadedUserBookings.filter((booking) => {
        return (
          booking.borrowerID === this.userId &&
          booking.status === "pending-return"
        );
      });
    },

    bookingsReceivedIssue() {
      return this.$store.getters.loadedUserBookings.filter((booking) => {
        return booking.lenderID === this.userId && booking.status === "issue";
      });
    },

    bookingsPlacedIssue() {
      return this.$store.getters.loadedUserBookings.filter((booking) => {
        return booking.borrowerID === this.userId && booking.status === "issue";
      });
    },

    bookingsAwaitingImages() {
      return this.$store.getters.loadedUserBookings.filter((booking) => {
        return (
          booking.lenderID === this.userId &&
          booking.status === "awaiting-images"
        );
      });
    },

    // bookingsReceivedCompleted() {
    //   return this.bookings.filter((booking) => {
    //     return (
    //       (booking.status === 'complete' && booking.lenderID === this.userId) ||  (booking.status === 'returnedL' && booking.lenderID === this.userId) ||(booking.status === 'awaiting-deposit' && (booking.lenderID === this.userId))
    //     );
    //   });
    // },

    bookingsPlacedCompleted() {
      return this.$store.getters.loadedUserBookings.filter((booking) => {
        return (
          (booking.status === "complete" &&
            booking.borrowerID === this.userId) ||
          (booking.status === "returnedB" && booking.borrowerID === this.userId)
        );
      });
    },

    bookingsPlacedAwaitingDeposit() {
      return this.$store.getters.loadedUserBookings.filter((booking) => {
        return (
          (booking.status === "awaiting-deposit" &&
            booking.borrowerID === this.userId) ||
          (booking.status === "returnedB" &&
            booking.borrowerID === this.userId &&
            booking.deposit != undefined)
        );
      });
    },

    completed() {
      return this.$store.getters.loadedUserBookings.filter((booking) => {
        return (
          (booking.status === "complete" &&
            (booking.lenderID === this.userId ||
              booking.borrowerID === this.userId)) ||
          (booking.status === "returnedB" &&
            booking.borrowerID === this.userId &&
            booking.deposit === undefined) ||
          (booking.status === "returnedL" &&
            booking.lenderID === this.userId) ||
          (booking.status === "awaiting-deposit" &&
            booking.lenderID === this.userId)
        );
      });
    },

    bookingsPlaced() {
      return this.$store.getters.loadedUserBookings.filter((booking) => {
        return (
          booking.borrowerID === this.userId &&
          booking.status !== "returned" &&
          booking.status !== "returnedL" &&
          booking.status !== "returnedB" &&
          booking.status !== "complete" &&
          booking.status !== "cancelled" &&
          booking.status !== "awaiting-deposit"
        );
      });
    },
    bookingsPlacedPending() {
      return this.$store.getters.loadedUserBookings
        .filter((booking) => {
          return (
            booking.borrowerID === this.userId && booking.status === "pending"
          );
        })
        .sort(function (a, b) {
          // Turn your strings into dates, and then subtract them
          // to get a value that is either negative, positive, or zero.
          // console.log('date: ' + b.endDate);
          return new Date(b.endDate) - new Date(a.endDate);
        });
    },
    bookingsPlacedAwaitingPayment() {
      // this.refreshKey;
      return this.$store.getters.loadedUserBookings
        .filter((booking) => {
          return (
            booking.borrowerID === this.userId &&
            booking.status === "awaiting-payment"
          );
        })
        .sort(function (a, b) {
          // Turn your strings into dates, and then subtract them
          // to get a value that is either negative, positive, or zero.
          return new Date(b.endDate) - new Date(a.endDate);
        });
    },
    bookingsPlacedActive() {
      // this.refreshKey;
      return this.$store.getters.loadedUserBookings
        .filter((booking) => {
          return (
            booking.borrowerID === this.userId && booking.status === "active"
          );
        })
        .sort(function (a, b) {
          // Turn your strings into dates, and then subtract them
          // to get a value that is either negative, positive, or zero.
          return new Date(b.endDate) - new Date(a.endDate);
        });
    },

    bookingsPlacedFinalised() {
      return this.$store.getters.loadedUserBookings
        .filter((booking) => {
          return (
            (booking.borrowerID === this.userId &&
              booking.status === "finalised") ||
            (booking.borrowerID === this.userId &&
              booking.status === "awaiting-images")
          );
        })
        .sort(function (a, b) {
          // Turn your strings into dates, and then subtract them
          // to get a value that is either negative, positive, or zero.
          return new Date(b.endDate) - new Date(a.endDate);
        });
    },

    bookingsPlacedDeclined() {
      return this.$store.getters.loadedUserBookings
        .filter((booking) => {
          return (
            booking.borrowerID === this.userId && booking.status === "declined"
          );
        })
        .sort(function (a, b) {
          // Turn your strings into dates, and then subtract them
          // to get a value that is either negative, positive, or zero.
          return new Date(b.endDate) - new Date(a.endDate);
        });
    },

    bookingsPlacedOverdue() {
      return this.$store.getters.loadedUserBookings
        .filter((booking) => {
          return (
            booking.borrowerID === this.userId && booking.status === "overdue"
          );
        })
        .sort(function (a, b) {
          // Turn your strings into dates, and then subtract them
          // to get a value that is either negative, positive, or zero.
          return new Date(b.endDate) - new Date(a.endDate);
        });
    },

    bookingsPlacedCompleted() {
      return this.$store.getters.loadedUserBookings
        .filter((booking) => {
          return (
            (booking.status === "complete" &&
              booking.borrowerID === this.userId) ||
            (booking.status === "returnedB" &&
              booking.borrowerID === this.userId)
          );
        })
        .sort(function (a, b) {
          // Turn your strings into dates, and then subtract them
          // to get a value that is either negative, positive, or zero.
          return new Date(b.endDate) - new Date(a.endDate);
        });
    },

    bookingsPlacedCancelled() {
      return this.$store.getters.loadedUserBookings
        .filter((booking) => {
          return (
            booking.borrowerID === this.userId && booking.status === "cancelled"
          );
        })
        .sort(function (a, b) {
          // Turn your strings into dates, and then subtract them
          // to get a value that is either negative, positive, or zero.
          return new Date(b.endDate) - new Date(a.endDate);
        });
    },

    bookingsReceived() {
      // console.log('bookings received: ', this.bookings);
      // this.refreshKey;
      return this.$store.getters.loadedUserBookings
        .filter((booking) => {
          console.log("getter");
          return (
            booking.lenderID === this.userId
            //&&
            // booking.status !== "complete" &&
            // booking.status !== "returned" &&
            // booking.status !== "returnedL" &&
            // booking.status !== "cancelled" &&
            // booking.status !== "returnedB" &&
            // booking.status !== "awaiting-deposit"
          );
        })
        .sort(function (a, b) {
          // Turn your strings into dates, and then subtract them
          // to get a value that is either negative, positive, or zero.
          return new Date(b.endDate) - new Date(a.endDate);
        });
    },

    bookingsReceivedAwaitingPayment() {
      // console.log('bookings awaiting payment');
      // this.refreshKey;

      return this.$store.getters.loadedUserBookings
        .filter((booking) => {
          return (
            booking.lenderID === this.userId &&
            booking.status === "awaiting-payment"
          );
        })
        .sort(function (a, b) {
          // Turn your strings into dates, and then subtract them
          // to get a value that is either negative, positive, or zero.
          return new Date(b.endDate) - new Date(a.endDate);
        });
    },
    bookingsReceivedPending() {
      // console.log('bookings pending');
      // this.refreshKey;
      try {
        return this.$store.getters.loadedUserBookings
          .filter((booking) => {
            return (
              booking.lenderID === this.userId && booking.status === "pending"
            );
          })
          .sort(function (a, b) {
            // Turn your strings into dates, and then subtract them
            // to get a value that is either negative, positive, or zero.
            return new Date(b.endDate) - new Date(a.endDate);
          });
      } catch (e) {
        console.log("error: ", e);
        // this.reload();
      }
    },
    bookingsReceivedActive() {
      // this.refreshKey;
      return this.$store.getters.loadedUserBookings
        .filter((booking) => {
          return (
            booking.lenderID === this.userId && booking.status === "active"
          );
        })
        .sort(function (a, b) {
          // Turn your strings into dates, and then subtract them
          // to get a value that is either negative, positive, or zero.
          return new Date(b.endDate) - new Date(a.endDate);
        });
    },

    bookingsReceivedFinalised() {
      return this.$store.getters.loadedUserBookings
        .filter((booking) => {
          return (
            (booking.lenderID === this.userId &&
              booking.status === "finalised") ||
            (booking.lenderID === this.userId &&
              booking.status === "awaiting-images")
          );
        })
        .sort(function (a, b) {
          // Turn your strings into dates, and then subtract them
          // to get a value that is either negative, positive, or zero.
          return new Date(b.endDate) - new Date(a.endDate);
        });
    },

    bookingsReceivedCompleted() {
      return this.$store.getters.loadedUserBookings
        .filter((booking) => {
          return (
            (booking.status === "complete" &&
              booking.lenderID === this.userId) ||
            (booking.status === "returnedL" &&
              booking.lenderID === this.userId) ||
            (booking.lenderID === this.userId &&
              booking.status === "awaiting-deposit")
          );
        })
        .sort(function (a, b) {
          // Turn your strings into dates, and then subtract them
          // to get a value that is either negative, positive, or zero.
          return new Date(b.endDate) - new Date(a.endDate);
        });
    },

    bookingsReceivedCancelled() {
      return this.$store.getters.loadedUserBookings
        .filter((booking) => {
          return (
            booking.lenderID === this.userId && booking.status === "cancelled"
          );
        })
        .sort(function (a, b) {
          // Turn your strings into dates, and then subtract them
          // to get a value that is either negative, positive, or zero.
          return new Date(b.endDate) - new Date(a.endDate);
        });
    },

    bookingsReceivedOverDue() {
      return this.$store.getters.loadedUserBookings
        .filter((booking) => {
          return (
            booking.lenderID === this.userId && booking.status === "overdue"
          );
        })
        .sort(function (a, b) {
          // Turn your strings into dates, and then subtract them
          // to get a value that is either negative, positive, or zero.
          return new Date(b.endDate) - new Date(a.endDate);
        });
    },
  },

  methods: {
    //     delay(ms) {
    //   return new Promise( resolve => setTimeout(resolve, ms) );
    // },

    redirectToOnboarding() {
      console.log(this.Onboarded);
      console.log(this.user);
      // Check if the user is not onboarded
      if (this.Onboarded == false) {
        // Redirect the user to the onboarding page
        this.$router.push("/onboarding");
      }
    },

    log() {
      console.log(this.bookingsPlacedActive);
    },

    endReview() {
      console.log("Are we here????");
      this.$store.commit("clearReviewSuccess");
      this.$store.commit("setLoading", false);
      // this.bookingsReceivedReturned[0] = _.find(this.$store.getters.loadedUserBookings, {
      //   id: this.$route.params.id,
      // });
      // this.bookingsReceivedReturned[0].status = 'returned';
    },

    closePaymentSuccessDialog() {
      this.paymentSuccessDialog = false;
      this.paymentSuccess = false;
      // this.$store.commit('setPaymentSucces', false);
    },
    changeState: function (newState) {
      this.tabState = newState;
    },
    changeReviewState: function (newState) {
      this.reviewState = newState;
    },
    changeBookingState: function (newState) {
      this.bookingState = newState;
    },
    changeReturnedState: function (newState) {
      this.returnedState = newState;
    },
    onScroll(e) {
      if (typeof window === "undefined") return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.fab = top > 20;
    },
    toTop() {
      this.$vuetify.goTo(0);
    },

    showToast(msg) {
      console.log("fire toast");
      this.snackbar = true;
      this.text = msg;
    },

    loadParam() {
      console.log("params changes");
      this.$router.go();
    },
    refresh() {
      this.$router.push("/dashboard").catch((err) => {});
    },
    reload() {
      //  Vue.prototype.$dashState = 'bookingsReceived'
      // // this.$store.commit('loadBookings');
      // //  this.$store.dispatch('loadedBooking')
      //   //  this.$store.dispatch('loadBookings');
      //    this.$router.go()
      // this.$store.replaceState()
      // console.log('reload')
      //  this.refreshKey = !this.refreshKey;
      // let data = {
      //   tab_state: 'requests',
      // };

      // console.log('tabState', this.tabState);
      if (this.tabState == "listings") {
        this.$router.push("/dashboard?s=1");
      } else if (this.tabState == "bookings-received") {
        this.$router.push("/dashboard?s=2");
      } else if (this.tabState == "bookings-placed") {
        this.$router.push("/dashboard?s=3");
      }

      // console.log('am i evn do anything');
      this.$router.go("/dashboard?s=" + this.state1).catch((err) => {});
      // {
      //       name: "Dashboard 📊", //use name for router push
      //       params: { data: 'requests' },
      //       query: { s: '1' }
      //     }
      //   )
    },

    onSaveChanges() {
      Toast.fire({
        title: "Account preferences updated successfully!",
      });
      this.dialog1 = false;
    },

    onLogout() {
      this.$store.dispatch("logout");
      this.$router.push("/");
    },

    approveReturn(booking) {
      try {
        var bookingRef = firebase
          .firestore()
          .collection("bookings")
          .doc(booking.id);
        bookingRef.update({
          status: "returned",
          updatedAt: new Date(),
        });
      } catch (e) {
        const errorMessage = error.message;
        alert(errorMessage);
      } finally {
        this.returnedDialog = true;
      }
    },

    acceptBooking(booking) {
      // console.log(booking);
      console.log(booking);
      try {
        var bookingRef = firebase
          .firestore()
          .collection("bookings")
          .doc(booking.id);

        bookingRef.update({
          status: "awaiting-payment",
          updatedAt: new Date(),
        });
      } catch (e) {
        const errorMessage = error.message;
        alert(errorMessage);
      } finally {
        this.acceptedDialog = true;
      }
      try {
        var addMessage = firebase
          .functions()
          .httpsCallable("bookingRequestAccepted");
        addMessage({
          email: booking.borrowerEmail,
          id: booking.id,
          borrowerName: booking.borrowerName,
          itemName: booking.itemName,
        });
      } catch (e) {
        const errorMessage = error.message;
        alert(errorMessage);
      }
    },

    delay(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },

    firestore() {
      const user = fb.auth().currentUser;
      return {
        profile: db.collection("users").doc(user.uid),
      };
    },
  },
};
</script>
<template>
  <div class="ml-5">
    <!-- <v-overlay opacity="0.8" v-if="loading">
      <Loader class="loading-page" />
    </v-overlay> -->
    <v-dialog
      v-model="signupDialog"
      scrollable
      :overlay="false"
      max-width="568px"
      transition="dialog-transition"
    >
      <SignupComponent
        :shouldRedirect="false"
        @loggedIn="signupDialog = false"
        :fromPage="true"
        :addItem="false"
        :addBooking="false"
        @changeDialog="
          signupDialog = false;
          loginDialog = true;
        "
      />
    </v-dialog>

    <!-- Refresh Dialog -->
    <v-dialog v-if="refreshDialog == true">
      <v-card class="grid pa-7">
        <div class="text-h2">
          New data is available. please refresh the page
        </div>

        <v-btn class="appbutton" @click="refresh()">Refresh</v-btn>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="loginDialog"
      scrollable
      persistent
      :overlay="false"
      max-width="568px"
      transition="dialog-transition"
    >
      <LoginComponent
        :shouldRedirect="false"
        :fromPage="true"
        :addItem="false"
        :addBooking="false"
        @loggedIn="loginDialog = false"
        @changeDialog="
          loginDialog = false;
          signupDialog = true;
        "
      />
    </v-dialog>

    <div v-if="loading">
      <dash-loader />
    </div>

    <v-row v-if="!loading" class="mb-8">
      <!-- <v-col class="fixed" cols="12" sm="4" md="3" lg="2">
        <profile
          @profileVerified="verified = $event"
          :isProfileVerified="verified"
        />
      </v-col> -->
      <v-col cols="12">
        <div class="text-center mb-4">
          <h4
            :class="[$vuetify.breakpoint.mdAndUp ? 'headline' : 'headline']"
            class="text-center font-weight-bold"
          >
            My Dashboard
          </h4>

          <!-- <p>{{ this.bookingsReceivedReturned }} </p> -->

          <div class="mt-3">
            <v-btn
              :x-small="$vuetify.breakpoint.smAndDown"
              :style="
                tabState === 'listings'
                  ? 'border-bottom: 5px solid #B22AF0;'
                  : ''
              "
              :class="tabState == 'listings' ? 'selected' : 'not-selected'"
              class="mr-2"
              @click="changeState('listings')"
              text
            >
              <v-badge
                :value="items.length > 0 === true"
                color="#b22af0"
                :content="items.length"
              >
                Listings</v-badge
              >
            </v-btn>
            <v-btn
              :x-small="$vuetify.breakpoint.smAndDown"
              @click="changeState('bookings-received')"
              :style="
                tabState === 'bookings-received'
                  ? 'border-bottom: 5px solid #B22AF0;'
                  : ''
              "
              :class="
                tabState == 'bookings-received' ? 'selected' : 'not-selected'
              "
              text
            >
              <v-badge
                :value="
                  bookingsReceivedPending.length > 0 === true ||
                  bookingsReceivedAwaitingPayment.length > 0 === true ||
                  bookingsReceivedActive.length > 0 === true ||
                  bookingsReceivedFinalised.length > 0 === true ||
                  bookingsReceivedPendingReturn.length > 0 === true ||
                  bookingsReceivedIssue.length > 0 === true
                "
                color="#b22af0"
                :content="
                  bookingsReceivedPending.length +
                  bookingsReceivedAwaitingPayment.length +
                  bookingsReceivedActive.length +
                  bookingsReceivedFinalised.length +
                  bookingsReceivedPendingReturn.length +
                  bookingsReceivedIssue.length
                "
              >
                Bookings Received</v-badge
              >
            </v-btn>

            <!-- <v-btn
            v-if="bookingsReceived.length < 1"
                :x-small="$vuetify.breakpoint.smAndDown"
                @click="changeState('bookings-received')"
                :style="
                  state === 'bookings-received'
                    ? 'border-bottom: 5px solid #B22AF0;'
                    : ''
                "
                text
                >Bookings Received</v-btn
              > -->
            <v-btn
              :x-small="$vuetify.breakpoint.smAndDown"
              @click="changeState('bookings-placed')"
              :style="
                tabState === 'bookings-placed'
                  ? 'border-bottom: 5px solid #B22AF0;'
                  : ''
              "
              :class="
                tabState == 'bookings-placed' ? 'selected' : 'not-selected'
              "
              text
            >
              <v-badge
                :value="
                  bookingsPlacedPending.length > 0 === true ||
                  bookingsPlacedAwaitingPayment.length > 0 === true ||
                  bookingsPlacedActive.length > 0 === true ||
                  bookingsPlacedFinalised.length > 0 === true ||
                  bookingsPlacedPendingReturn.length > 0 === true ||
                  bookingsPlacedIssue.length > 0 === true
                "
                color="#b22af0"
                :content="
                  bookingsPlacedPending.length +
                  bookingsPlacedAwaitingPayment.length +
                  bookingsPlacedActive.length +
                  bookingsPlacedFinalised.length +
                  bookingsPlacedPendingReturn.length +
                  bookingsPlacedIssue.length
                "
              >
                Bookings Placed</v-badge
              >
            </v-btn>

            <!-- <v-btn
            v-if="bookingsPlaces.length < 1"
                :x-small="$vuetify.breakpoint.smAndDown"
                @click="changeState('bookings-placed')"
                :style="
                  state === 'bookings-placed'
                    ? 'border-bottom: 5px solid #B22AF0;'
                    : ''
                "
                text
                >Bookings Placed</v-btn
              > -->
          </div>
        </div>

        <template v-if="tabState === 'listings'">
          <v-row v-if="items.length < 1" class="mb-2 grid mt-5">
            <p class="text-h4">No listings yet.</p>
            When you list an item(s) it will show up here.
            <v-img
              width="150px"
              height="150px"
              :src="require('@/assets/svgs/error-2.svg')"
            />
            <v-btn
              class="appbutton mx-1 mt-3 white--text font-weight-medium"
              color="accent"
              rounded
              to="/items/new"
              z-index="12"
            >
              <v-icon x-small class="mr-1">fas fa-plus</v-icon>Add an Item
            </v-btn>
          </v-row>

          <v-col v-else>
            <v-row class="grid">
              <h4>All the items you've listed are shown below.</h4>
            </v-row>
            <v-row class="mb-2" :class="$vuetify.breakpoint.xs ? 'grid' : ''">
              <div v-for="item in items" :key="item.id">
                <div>
                  <div
                    class="ma-2 item"
                    @click="
                      $router.push(
                        '/items/' + item.itemName.replace(/\s+/g, '-')
                      )
                    "
                  >
                    <v-card
                      :width="$vuetify.breakpoint.xs ? '80vw' : '180px'"
                      :height="$vuetify.breakpoint.xs ? '250px' : '180px'"
                      class="card ma-2 ma-md-0"
                      style="border-radius: 12px"
                    >
                      <v-img
                        :width="$vuetify.breakpoint.xs ? '80vw' : '180px'"
                        :src="item.images ? item.images[0] : ''"
                        :height="$vuetify.breakpoint.xs ? '250px' : '180px'"
                      />
                    </v-card>

                    <div class="clip text-body-1 black--text mb-0">
                      {{ item.itemName }}
                    </div>

                    <div>R{{ item.dailyFee }} p/day</div>

                    <div
                      :class="
                        item.availabilty == true ? 'green--text' : 'red--text'
                      "
                    >
                      {{
                        item.availabilty == true
                          ? "Available "
                          : "Not Available"
                      }}
                    </div>
                  </div>
                </div>
              </div>
            </v-row>
          </v-col>
        </template>
        <template v-if="tabState === 'bookings-received'">
          <v-row v-if="bookingsReceived.length < 1" class="mb-2 grid mt-5">
            <p class="text-h4">No bookings received yet.</p>
            When someone requests to borrow one of item(s) it will show up here.
            <v-img
              width="150px"
              height="150px"
              :src="require('@/assets/svgs/email-2.svg')"
            />
            <v-btn
              class="appbutton mx-1 mt-3 white--text font-weight-medium"
              color="accent"
              rounded
              to="/items/new"
              z-index="12"
            >
              <v-icon x-small class="mr-1">fas fa-plus</v-icon>Add an Item
            </v-btn>
          </v-row>

          <v-col v-else>
            <v-row class="grid">
              <h4>
                When people request to borrow your items they will show up here
              </h4>
            </v-row>

            <v-row>
              <v-col cols="11" class="d-flex justify-space-between mt-4">
                <div class="hidden-sm-and-down">
                  <v-btn
                    small
                    text
                    @click="recievedView = 'all'"
                    :class="recievedView == 'all' ? 'selected' : 'not-selected'"
                  >
                    All</v-btn
                  >
                  <v-btn
                    v-if="bookingsReceivedPending.length != 0"
                    @click="recievedView = 'pending'"
                    small
                    text
                    :class="
                      recievedView == 'pending' ? 'selected' : 'not-selected'
                    "
                  >
                    pending acceptance</v-btn
                  >
                  <v-btn
                    v-if="bookingsReceivedAwaitingPayment.length != 0"
                    @click="recievedView = 'awaiting-payment'"
                    small
                    text
                    :class="
                      recievedView == 'awaiting-payment'
                        ? 'selected'
                        : 'not-selected'
                    "
                  >
                    Waiting for payment</v-btn
                  >
                  <v-btn
                    v-if="bookingsReceivedFinalised.length != 0"
                    small
                    text
                    @click="recievedView = 'finalised'"
                    :class="
                      recievedView == 'finalised' ? 'selected' : 'not-selected'
                    "
                  >
                    Finalised</v-btn
                  >
                  <v-btn
                    small
                    text
                    @click="recievedView = 'active'"
                    :class="
                      recievedView == 'active' ? 'selected' : 'not-selected'
                    "
                    v-if="bookingsReceivedActive.length !== 0"
                  >
                    Active</v-btn
                  >

                  <v-btn
                    small
                    text
                    @click="recievedView = 'past'"
                    :class="
                      recievedView == 'past' ? 'selected' : 'not-selected'
                    "
                    v-if="
                      bookingsReceivedReturned.length > 0 ||
                      bookingsReceivedCompleted.length > 0 ||
                      bookingsReceivedCancelled.length > 0
                    "
                  >
                    Past
                  </v-btn>
                </div>

                <div>
                  <v-select
                    label="Filter booking status"
                    v-model="recievedView"
                    :items="receivedBookingStates"
                    class="round hidden-md-and-up"
                    outlined
                    small
                    color="rgb(34, 34, 34)"
                  />
                </div>

                <v-spacer />

                <div>
                  <v-switch
                    v-model="receivedTableSwitch"
                    class="ma-2 ml-2"
                    inset
                    color="accent"
                    small
                    :label="
                      receivedTableSwitch == true ? 'Card View' : 'Table View'
                    "
                  ></v-switch>
                </div>
              </v-col>
            </v-row>

            <div v-if="bookingState === 'pending'" class="my-4">
              <v-row v-if="receivedTableSwitch == true">
                <v-col cols="12">
                  <bookings-received-table
                    :bookingsReceived="bookingsReceived"
                    class="mt-8"
                  />
                </v-col>
              </v-row>

              <v-row v-if="receivedTableSwitch == false">
                <template
                  v-if="
                    (recievedView == 'issue' &&
                      bookingsReceivedIssue.length !== 0) ||
                    (recievedView == 'all' &&
                      bookingsReceivedIssue.length !== 0)
                  "
                >
                  <v-col
                    cols="12"
                    sm="6"
                    lg="3"
                    v-for="booking in bookingsReceivedIssue"
                    :key="booking.id"
                  >
                    <v-card
                      :to="'/booking' + '/' + booking.id"
                      style="border-radius: 12px"
                      class="ma-2"
                      color="lgrey"
                      elevation="4"
                    >
                      <v-row class="card-head">
                        <v-col
                          style="padding: 8px; padding-left: 16px"
                          cols="10"
                        >
                          <h4>
                            <span class="white--text">Booking Issue</span>
                          </h4>
                        </v-col>
                        <v-col class="center" style="margin: 0px" cols="2">
                          <v-icon
                            @click="
                              showToast(
                                'A support ticket has been logged with our helpdesk related to this booking.'
                              )
                            "
                            style="
                              color: white;
                              float: right;
                              align-self: right;
                            "
                            small
                            class="mr-1"
                            >fas fa-info-circle</v-icon
                          >
                        </v-col>
                      </v-row>
                      <v-col cols="12 pa-6">
                        <v-row>
                          <v-col cols="6">
                            <v-card
                              height="125px"
                              width="125px"
                              class="card ma-3"
                              style="border-radius: 12px"
                            >
                              <v-img
                                :src="booking.images ? booking.images[0] : ''"
                                height="125px"
                                width="125px"
                              />
                            </v-card>
                          </v-col>
                          <v-col cols="6">
                            <div
                              class="ma-3 mt-md-4 mt-1 mt-sm-2 my-auto text-caption text-sm-body-2"
                            >
                              <div
                                class="ml-n3 my-1 my-md-4 black--text clip-booking"
                              >
                                <span class="font-weight-bold clip-booking">{{
                                  booking.itemName
                                }}</span>
                              </div>

                              <div class="ml-n3 my-1 my-md-4 my-2 clip-booking">
                                <span class="font-weight-bold">
                                  {{ booking.startDate }} -
                                  {{ booking.endDate }}</span
                                >
                              </div>
                              <!-- <div class="ml-n3 my-1 my-md-4 my-2">
                                Length:
                                <span class="font-weight-bold">
                                  {{ booking.dateRange }} days</span
                                >
                              </div> -->

                              <!-- <div class="ml-n3 my-1 my-md-4 my-2">
                              <span color="black"
                                >Date:
                                <span class="font-weight-bold">
                                  {{ booking.date }}</span
                                >
                              </span>
                            </div> -->

                              <div class="ml-n3 my-1 my-md-4 my-2">
                                Total:
                                <span class="font-weight-bold borrowername">
                                  R{{ booking.total }}</span
                                >
                              </div>

                              <div
                                class="ml-n3 my-1 my-md-4 my-2 borrowername"
                                style="cursor: pointer"
                              >
                                <v-avatar
                                  v-if="booking.lenderAvatar"
                                  outline
                                  size="25"
                                  class="mr-1 mt-n2"
                                  style="margin-bottom: -3px"
                                >
                                  <v-img :src="booking.lenderAvatar"></v-img>
                                </v-avatar>
                                <svg
                                  v-else-if="!booking.lenderAvatar"
                                  viewBox="0 0 32 32"
                                  class="mr-1"
                                  xmlns="http://www.w3.org/2000/svg"
                                  :style="
                                    $vuetify.breakpoint.xsOnly
                                      ? 'height: 15px; width: 15px;'
                                      : '' && $vuetify.breakpoint.smAndDown
                                      ? 'height: 20px; width: 20px;'
                                      : 'height: 20px; width: 20px;' &&
                                        $vuetify.breakpoint.mdAndUp
                                      ? 'height: 20px; width: 20px;'
                                      : 'height: 20px; width: 20px;'
                                  "
                                  style="
                                    fill: currentcolor;
                                    margin-bottom: -3px;
                                  "
                                  aria-label="Profile button"
                                  role="presentation"
                                  focusable="false"
                                >
                                  <path
                                    d="m16 .7c-8.437 0-15.3 6.863-15.3 15.3s6.863 15.3 15.3 15.3 15.3-6.863 15.3-15.3-6.863-15.3-15.3-15.3zm0 28c-4.021 0-7.605-1.884-9.933-4.81a12.425 12.425 0 0 1 6.451-4.4 6.507 6.507 0 0 1 -3.018-5.49c0-3.584 2.916-6.5 6.5-6.5s6.5 2.916 6.5 6.5a6.513 6.513 0 0 1 -3.019 5.491 12.42 12.42 0 0 1 6.452 4.4c-2.328 2.925-5.912 4.809-9.933 4.809z"
                                  ></path>
                                </svg>
                                <span
                                  class="font-weight-bold borrowername text-subtitle-1 clip-booking"
                                >
                                  {{ booking.lenderName }}
                                </span>
                              </div>
                            </div>
                          </v-col>
                        </v-row>
                        <v-row class="grid"
                          ><v-btn
                            rounded
                            :to="'/booking' + '/' + booking.id"
                            class="hidden mx-1 white app--text font-weight-medium"
                            z-index="12"
                          >
                            <u>View Booking</u>
                            <v-icon
                              style="
                                margin-left: 8px;
                                float: right;
                                align-self: right;
                              "
                              x-small
                              class="mr-1"
                            >
                              fas fa-chevron-right</v-icon
                            >
                          </v-btn></v-row
                        >
                      </v-col>
                    </v-card>
                  </v-col>
                </template>

                <!-- PENDING RETURN -->
                <template
                  v-if="
                    (recievedView == 'pending-return' &&
                      bookingsReceivedPendingReturn.length !== 0) ||
                    (recievedView == 'all' &&
                      bookingsReceivedPendingReturn.length !== 0)
                  "
                >
                  <v-col
                    cols="12"
                    sm="6"
                    lg="3"
                    v-for="booking in bookingsReceivedPendingReturn"
                    :key="booking.id"
                  >
                    <v-card
                      :to="'/booking' + '/' + booking.id"
                      style="border-radius: 12px"
                      class="ma-2"
                      color="lgrey"
                      elevation="4"
                    >
                      <v-row class="card-head">
                        <v-col
                          style="padding: 8px; padding-left: 16px"
                          cols="10"
                        >
                          <h4>
                            <span class="white--text">Pending Return</span>
                          </h4>
                        </v-col>
                        <v-col class="center" style="margin: 0px" cols="2">
                          <v-icon
                            @click.prevent="
                              showToast(
                                'This booking has ended. Once ' +
                                  booking.borrowerName +
                                  ' has returned your item please use the button below to confirm. If there are any issues please log a ticket with our helpdesk.'
                              )
                            "
                            style="
                              color: white;
                              float: right;
                              align-self: right;
                            "
                            small
                            class="mr-1"
                            >fas fa-info-circle</v-icon
                          >
                        </v-col>
                      </v-row>
                      <v-col cols="12 pa-6">
                        <v-row>
                          <v-col cols="6">
                            <v-card
                              height="125px"
                              width="125px"
                              class="card ma-3"
                              style="border-radius: 12px"
                            >
                              <v-img
                                :src="booking.images ? booking.images[0] : ''"
                                height="125px"
                                width="125px"
                              />
                            </v-card>
                          </v-col>
                          <v-col cols="6">
                            <div
                              class="ma-3 mt-md-4 mt-1 mt-sm-2 my-auto text-caption text-sm-body-2"
                            >
                              <div
                                class="ml-n3 my-1 my-md-4 black--text clip-booking"
                              >
                                <span class="font-weight-bold clip-booking">{{
                                  booking.itemName
                                }}</span>
                              </div>

                              <div class="ml-n3 my-1 my-md-4 my-2 clip-booking">
                                <span class="font-weight-bold clip-booking">
                                  {{ booking.startDate }} -
                                  {{ booking.endDate }}</span
                                >
                              </div>
                              <!-- <div class="ml-n3 my-1 my-md-4 my-2">
                                Length:
                                <span class="font-weight-bold">
                                  {{ booking.dateRange }} days</span
                                >
                              </div> -->

                              <div class="ml-n3 my-1 my-md-4 my-2 borrowername">
                                <span color="black"
                                  >Receivable:
                                  <span class="font-weight-bold">
                                    R{{ booking.lenderReceivable }}</span
                                  >
                                </span>
                              </div>

                              <div
                                class="ml-n3 my-1 my-md-4 my-2 borrowername"
                                style="cursor: pointer"
                              >
                                <v-avatar
                                  v-if="booking.borrowerAvatar"
                                  outline
                                  size="25"
                                  class="mr-1 mt-n2"
                                  style="margin-bottom: -3px"
                                >
                                  <v-img :src="booking.borrowerAvatar"></v-img>
                                </v-avatar>
                                <svg
                                  v-else-if="!booking.borrowerAvatar"
                                  viewBox="0 0 32 32"
                                  class="mr-1"
                                  xmlns="http://www.w3.org/2000/svg"
                                  :style="
                                    $vuetify.breakpoint.xsOnly
                                      ? 'height: 15px; width: 15px;'
                                      : '' && $vuetify.breakpoint.smAndDown
                                      ? 'height: 20px; width: 20px;'
                                      : 'height: 20px; width: 20px;' &&
                                        $vuetify.breakpoint.mdAndUp
                                      ? 'height: 20px; width: 20px;'
                                      : 'height: 20px; width: 20px;'
                                  "
                                  style="
                                    fill: currentcolor;
                                    margin-bottom: -3px;
                                  "
                                  aria-label="Profile button"
                                  role="presentation"
                                  focusable="false"
                                >
                                  <path
                                    d="m16 .7c-8.437 0-15.3 6.863-15.3 15.3s6.863 15.3 15.3 15.3 15.3-6.863 15.3-15.3-6.863-15.3-15.3-15.3zm0 28c-4.021 0-7.605-1.884-9.933-4.81a12.425 12.425 0 0 1 6.451-4.4 6.507 6.507 0 0 1 -3.018-5.49c0-3.584 2.916-6.5 6.5-6.5s6.5 2.916 6.5 6.5a6.513 6.513 0 0 1 -3.019 5.491 12.42 12.42 0 0 1 6.452 4.4c-2.328 2.925-5.912 4.809-9.933 4.809z"
                                  ></path>
                                </svg>
                                <span
                                  class="font-weight-bold borrowername text-subtitle-1"
                                >
                                  {{ booking.borrowerName }}
                                </span>
                              </div>
                            </div>
                          </v-col>
                        </v-row>

                        <v-btn
                          large
                          block
                          class="mt-2 mb-0 appbutton rounded-lg white--text font-weight-medium text-body-2"
                          color="#B22AF0"
                          z-index="12"
                          :to="'/booking' + '/' + booking.id"
                          >Log Return</v-btn
                        >
                      </v-col>
                    </v-card>
                  </v-col>
                </template>

                <template
                  v-if="
                    (recievedView == 'pending' &&
                      bookingsReceivedPending.length !== 0) ||
                    (recievedView == 'all' &&
                      bookingsReceivedPending.length !== 0)
                  "
                >
                  <v-col cols="12">
                    <v-row class="my-4">
                      <h3>
                        Pending Acceptance ({{
                          bookingsReceivedPending.length
                        }})
                      </h3>
                    </v-row>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    lg="3"
                    v-for="booking in bookingsReceivedPending"
                    :key="booking.id"
                  >
                    <v-card
                      :to="'/booking' + '/' + booking.id"
                      style="border-radius: 12px"
                      class="ma-2"
                      color="lgrey"
                      elevation="4"
                    >
                      <v-row class="card-head">
                        <v-col
                          style="padding: 8px; padding-left: 16px"
                          cols="10"
                        >
                          <h4>
                            <span class="white--text">Booking Request</span>
                          </h4>
                        </v-col>
                        <v-col class="center" style="margin: 0px" cols="2">
                          <v-icon
                            @click.prevent="
                              showToast(
                                booking.borrowerName +
                                  ' has requested to book your item. You can choose to accept or decline this request.'
                              )
                            "
                            style="
                              color: white;images
                              float: right;
                              align-self: right;
                            "
                            small
                            class="mr-1"
                            >fas fa-info-circle</v-icon
                          >
                        </v-col>
                      </v-row>
                      <v-col cols="12 pa-6">
                        <v-row>
                          <v-col cols="6">
                            <v-card
                              height="125px"
                              width="125px"
                              class="card ma-3"
                              style="border-radius: 12px"
                            >
                              <v-img
                                :src="booking.images ? booking.images[0] : ''"
                                height="125px"
                                width="125px"
                              />
                            </v-card>
                          </v-col>
                          <v-col cols="6">
                            <div
                              class="ma-3 mt-md-4 mt-1 mt-sm-2 my-auto text-caption text-sm-body-2"
                            >
                              <div
                                class="ml-n3 my-1 my-md-4 black--text clip-booking"
                              >
                                <span class="font-weight-bold clip-booking">{{
                                  booking.itemName
                                }}</span>
                              </div>

                              <div class="ml-n3 my-1 my-md-4 my-2 clip-booking">
                                <span class="font-weight-bold clip-booking">
                                  {{ booking.startDate }} -
                                  {{ booking.endDate }}</span
                                >
                              </div>
                              <!-- <div class="ml-n3 my-1 my-md-4 my-2">
                                Length:
                                <span class="font-weight-bold">
                                  {{ booking.dateRange }} days</span
                                >
                              </div> -->

                              <div class="ml-n3 my-1 my-md-4 my-2 borrowername">
                                <span color="black"
                                  >Receivable:
                                  <span class="font-weight-bold">
                                    R{{ booking.lenderReceivable }}</span
                                  >
                                </span>
                              </div>

                              <div
                                class="ml-n3 my-1 my-md-4 my-2 borrowername"
                                style="cursor: pointer"
                              >
                                <v-avatar
                                  v-if="booking.borrowerAvatar"
                                  outline
                                  size="25"
                                  class="mr-1 mt-n2"
                                  style="margin-bottom: -3px"
                                >
                                  <v-img :src="booking.borrowerAvatar"></v-img>
                                </v-avatar>
                                <svg
                                  v-else-if="!booking.borrowerAvatar"
                                  viewBox="0 0 32 32"
                                  class="mr-1"
                                  xmlns="http://www.w3.org/2000/svg"
                                  :style="
                                    $vuetify.breakpoint.xsOnly
                                      ? 'height: 15px; width: 15px;'
                                      : '' && $vuetify.breakpoint.smAndDown
                                      ? 'height: 20px; width: 20px;'
                                      : 'height: 20px; width: 20px;' &&
                                        $vuetify.breakpoint.mdAndUp
                                      ? 'height: 20px; width: 20px;'
                                      : 'height: 20px; width: 20px;'
                                  "
                                  style="
                                    fill: currentcolor;
                                    margin-bottom: -3px;
                                  "
                                  aria-label="Profile button"
                                  role="presentation"
                                  focusable="false"
                                >
                                  <path
                                    d="m16 .7c-8.437 0-15.3 6.863-15.3 15.3s6.863 15.3 15.3 15.3 15.3-6.863 15.3-15.3-6.863-15.3-15.3-15.3zm0 28c-4.021 0-7.605-1.884-9.933-4.81a12.425 12.425 0 0 1 6.451-4.4 6.507 6.507 0 0 1 -3.018-5.49c0-3.584 2.916-6.5 6.5-6.5s6.5 2.916 6.5 6.5a6.513 6.513 0 0 1 -3.019 5.491 12.42 12.42 0 0 1 6.452 4.4c-2.328 2.925-5.912 4.809-9.933 4.809z"
                                  ></path>
                                </svg>
                                <span
                                  class="font-weight-bold borrowername text-subtitle-1"
                                >
                                  {{ booking.borrowerName }}
                                </span>
                              </div>
                            </div>
                          </v-col>
                        </v-row>

                        <v-btn
                          large
                          block
                          class="mt-2 mb-0 appbutton rounded-lg white--text font-weight-medium text-body-2"
                          color="#B22AF0"
                          z-index="12"
                          :to="'/booking' + '/' + booking.id"
                        >
                          Review Request</v-btn
                        >
                      </v-col>
                    </v-card>
                  </v-col>
                </template>

                <template
                  v-if="
                    (recievedView == 'finalised' &&
                      bookingsReceivedFinalised.length !== 0) ||
                    (recievedView == 'all' &&
                      bookingsReceivedFinalised.length !== 0)
                  "
                >
                  <v-col cols="12">
                    <v-row class="my-4">
                      <h3>
                        Finalised Bookings ({{
                          bookingsReceivedFinalised.length
                        }})
                      </h3>
                    </v-row>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    lg="3"
                    v-for="booking in bookingsReceivedFinalised"
                    :key="booking.id"
                  >
                    <v-card
                      :to="'/booking' + '/' + booking.id"
                      style="border-radius: 12px"
                      class="ma-2"
                      color="lgrey"
                      elevation="4"
                    >
                      <v-row class="card-head">
                        <v-col
                          style="padding: 8px; padding-left: 16px"
                          cols="10"
                        >
                          <h4>
                            <span class="white--text">Finalised booking</span>
                          </h4>
                        </v-col>
                        <v-col class="center" style="margin: 0px" cols="2">
                          <v-icon
                            @click.prevent="
                              showToast(
                                'All parties have approved this booking.'
                              )
                            "
                            style="
                              color: white;
                              float: right;
                              align-self: right;
                            "
                            small
                            class="mr-1"
                            >fas fa-info-circle</v-icon
                          >
                        </v-col>
                      </v-row>
                      <v-col cols="12 pa-6">
                        <v-row>
                          <v-col cols="6">
                            <v-card
                              height="125px"
                              width="125px"
                              class="card ma-3"
                              style="border-radius: 12px"
                            >
                              <v-img
                                :src="booking.images ? booking.images[0] : ''"
                                height="125px"
                                width="125px"
                              />
                            </v-card>
                          </v-col>
                          <v-col cols="6">
                            <div
                              class="ma-3 mt-md-4 mt-1 mt-sm-2 my-auto text-caption text-sm-body-2"
                            >
                              <div
                                class="ml-n3 my-1 my-md-4 black--text clip-booking"
                              >
                                <span class="font-weight-bold text-truncate">{{
                                  booking.itemName
                                }}</span>
                              </div>

                              <div class="ml-n3 my-1 my-md-4 my-2 clip-booking">
                                <span class="font-weight-bold clip-booking">
                                  {{ booking.startDate }} -
                                  {{ booking.endDate }}</span
                                >
                              </div>
                              <!-- <div class="ml-n3 my-1 my-md-4 my-2">
                                Length:
                                <span class="font-weight-bold">
                                  {{ booking.dateRange }} days</span
                                >
                              </div> -->

                              <div class="ml-n3 my-1 my-md-4 my-2 borrowername">
                                <span color="black"
                                  >Receivable:
                                  <span class="font-weight-bold">
                                    R{{ booking.lenderReceivable }}</span
                                  >
                                </span>
                              </div>
                              <div
                                class="ml-n3 my-1 my-md-4 my-2 borrowername"
                                style="cursor: pointer"
                              >
                                <v-avatar
                                  v-if="booking.borrowerAvatar"
                                  outline
                                  size="25"
                                  class="mr-1 mt-n2"
                                  style="margin-bottom: -3px"
                                >
                                  <v-img :src="booking.borrowerAvatar"></v-img>
                                </v-avatar>
                                <svg
                                  v-else
                                  viewBox="0 0 32 32"
                                  class="mr-1"
                                  xmlns="http://www.w3.org/2000/svg"
                                  :style="
                                    $vuetify.breakpoint.xsOnly
                                      ? 'height: 15px; width: 15px;'
                                      : '' && $vuetify.breakpoint.smAndDown
                                      ? 'height: 20px; width: 20px;'
                                      : 'height: 20px; width: 20px;' &&
                                        $vuetify.breakpoint.mdAndUp
                                      ? 'height: 20px; width: 20px;'
                                      : 'height: 20px; width: 20px;'
                                  "
                                  style="
                                    fill: currentcolor;
                                    margin-bottom: -3px;
                                  "
                                  aria-label="Profile button"
                                  role="presentation"
                                  focusable="false"
                                >
                                  <path
                                    d="m16 .7c-8.437 0-15.3 6.863-15.3 15.3s6.863 15.3 15.3 15.3 15.3-6.863 15.3-15.3-6.863-15.3-15.3-15.3zm0 28c-4.021 0-7.605-1.884-9.933-4.81a12.425 12.425 0 0 1 6.451-4.4 6.507 6.507 0 0 1 -3.018-5.49c0-3.584 2.916-6.5 6.5-6.5s6.5 2.916 6.5 6.5a6.513 6.513 0 0 1 -3.019 5.491 12.42 12.42 0 0 1 6.452 4.4c-2.328 2.925-5.912 4.809-9.933 4.809z"
                                  ></path>
                                </svg>
                                <span
                                  class="font-weight-bold borrowername text-subtitle-1"
                                >
                                  {{ booking.borrowerName }}
                                </span>
                              </div>
                            </div>
                          </v-col>
                        </v-row>
                        <!-- <v-row
                          v-if="booking.status === 'awaiting-images'"
                          class="text-center"
                          style="justify-content: center"
                        >
                          <h4>
                            <span class="black--text">Item Quality Check</span>
                          </h4>

                          We require you to upload current images of the item,
                          proving it's current working condition to assist with
                          any potential claims process.

                          <item-quality-dialog
                            :booking="booking"
                            style="margin-bottom: 16px"
                          >
                          </item-quality-dialog>
                        </v-row> -->
                        <!-- <v-row
                          v-else
                          class="text-center"
                          color="success"
                          style="justify-content: center"
                        >
                          <v-card
                            outlined
                            class="pa-2 round"
                            style="
                              background: #a0e6a0;
                              margin-bottom: 26px;
                              color: green;
                              font-weight: bold;
                              font-size: x-small;
                            "
                          >
                            <v-row class="center" style="margin: 2px">
                              <v-img
                                width="20px"
                                height="20px"
                                class="mr-3"
                                :src="
                                  require('@/assets/fontawesome/clipboard-list-check-duotone.svg')
                                "
                              />
                              Image(s) Uploaded
                            </v-row>
                          </v-card>
                        </v-row> -->
                        <v-row
                          class="grid"
                          v-if="booking.status === 'awaiting-images'"
                        >
                          <v-btn
                            large
                            block
                            class="mt-2 mb-0 appbutton rounded-lg white--text font-weight-medium text-body-2"
                            color="#B22AF0"
                            z-index="12"
                            :to="'/booking' + '/' + booking.id"
                          >
                            Upload Quality Check</v-btn
                          >
                        </v-row>
                        <v-row
                          v-else-if="booking.status === 'finalised'"
                          class="text-center"
                          color="success"
                          style="justify-content: center"
                        >
                          <v-btn
                            rounded
                            :to="'/booking' + '/' + booking.id"
                            class="hidden mx-1 white app--text font-weight-medium"
                            z-index="12"
                          >
                            <u>View Booking</u>
                            <v-icon
                              style="
                                margin-left: 8px;
                                float: right;
                                align-self: right;
                              "
                              x-small
                              class="mr-1"
                            >
                              fas fa-chevron-right</v-icon
                            >
                          </v-btn>
                        </v-row>
                      </v-col>
                    </v-card>
                  </v-col>
                </template>

                <template
                  v-if="
                    (recievedView == 'awaiting-payment' &&
                      bookingsReceivedAwaitingPayment.length !== 0) ||
                    (recievedView == 'all' &&
                      bookingsReceivedAwaitingPayment.length !== 0)
                  "
                >
                  <v-col cols="12">
                    <v-row class="my-4">
                      <h3>
                        Awaiting Payment ({{
                          bookingsReceivedAwaitingPayment.length
                        }})
                      </h3>
                    </v-row>
                  </v-col>

                  <v-col
                    cols="12"
                    sm="6"
                    lg="3"
                    v-for="booking in bookingsReceivedAwaitingPayment"
                    :key="booking.id"
                  >
                    <v-card
                      :to="'/booking' + '/' + booking.id"
                      style="border-radius: 12px"
                      class="ma-2"
                      color="lgrey"
                      elevation="4"
                    >
                      <v-row class="card-head">
                        <v-col
                          style="padding: 8px; padding-left: 16px"
                          cols="10"
                        >
                          <h4>
                            <span class="white--text">Awaiting payment</span>
                          </h4>
                        </v-col>
                        <v-col class="center" style="margin: 0px" cols="2">
                          <v-icon
                            @click.prevent="
                              showToast(
                                'You have approved this booking. Awaiting payment from ' +
                                  booking.borrowerName +
                                  '.'
                              )
                            "
                            style="
                              color: white;
                              float: right;
                              align-self: right;
                            "
                            small
                            class="mr-1"
                            >fas fa-info-circle</v-icon
                          >
                        </v-col>
                      </v-row>
                      <v-col cols="12 pa-6">
                        <v-row>
                          <v-col cols="6">
                            <v-card
                              height="125px"
                              width="125px"
                              class="card ma-3"
                              style="border-radius: 12px"
                            >
                              <v-img
                                :src="booking.images ? booking.images[0] : ''"
                                height="125px"
                                width="125px"
                              />
                            </v-card>
                          </v-col>
                          <v-col cols="6">
                            <div
                              class="ma-3 mt-md-4 mt-1 mt-sm-2 my-auto text-caption text-sm-body-2"
                            >
                              <div
                                class="ml-n3 my-1 my-md-4 black--text clip-booking"
                              >
                                <span class="font-weight-bold clip-booking">{{
                                  booking.itemName
                                }}</span>
                              </div>

                              <div class="ml-n3 my-1 my-md-4 my-2 clip-booking">
                                <span class="font-weight-bold clip-booking">
                                  {{ booking.startDate }} -
                                  {{ booking.endDate }}</span
                                >
                              </div>
                              <!-- <div class="ml-n3 my-1 my-md-4 my-2">
                                Length:
                                <span class="font-weight-bold">
                                  {{ booking.dateRange }} days</span
                                >
                              </div> -->

                              <div class="ml-n3 my-1 my-md-4 my-2 borrowername">
                                <span color="black"
                                  >Receivable:
                                  <span class="font-weight-bold">
                                    R{{ booking.lenderReceivable }}</span
                                  >
                                </span>
                              </div>
                              <div
                                class="ml-n3 my-1 my-md-4 my-2 borrowername"
                                style="cursor: pointer"
                              >
                                <v-avatar
                                  v-if="booking.borrowerAvatar"
                                  outline
                                  size="25"
                                  class="mr-1 mt-n2"
                                  style="margin-bottom: -3px"
                                >
                                  <v-img :src="booking.borrowerAvatar"></v-img>
                                </v-avatar>
                                <svg
                                  v-else
                                  viewBox="0 0 32 32"
                                  class="mr-1"
                                  xmlns="http://www.w3.org/2000/svg"
                                  :style="
                                    $vuetify.breakpoint.xsOnly
                                      ? 'height: 15px; width: 15px;'
                                      : '' && $vuetify.breakpoint.smAndDown
                                      ? 'height: 20px; width: 20px;'
                                      : 'height: 20px; width: 20px;' &&
                                        $vuetify.breakpoint.mdAndUp
                                      ? 'height: 20px; width: 20px;'
                                      : 'height: 20px; width: 20px;'
                                  "
                                  style="
                                    fill: currentcolor;
                                    margin-bottom: -3px;
                                  "
                                  aria-label="Profile button"
                                  role="presentation"
                                  focusable="false"
                                >
                                  <path
                                    d="m16 .7c-8.437 0-15.3 6.863-15.3 15.3s6.863 15.3 15.3 15.3 15.3-6.863 15.3-15.3-6.863-15.3-15.3-15.3zm0 28c-4.021 0-7.605-1.884-9.933-4.81a12.425 12.425 0 0 1 6.451-4.4 6.507 6.507 0 0 1 -3.018-5.49c0-3.584 2.916-6.5 6.5-6.5s6.5 2.916 6.5 6.5a6.513 6.513 0 0 1 -3.019 5.491 12.42 12.42 0 0 1 6.452 4.4c-2.328 2.925-5.912 4.809-9.933 4.809z"
                                  ></path>
                                </svg>
                                <span class="font-weight-bold text-subtitle-1">
                                  {{ booking.borrowerName }}
                                </span>
                              </div>
                            </div>
                          </v-col>
                        </v-row>
                        <v-row class="grid"
                          ><v-btn
                            rounded
                            :to="'/booking' + '/' + booking.id"
                            class="hidden mx-1 white app--text font-weight-medium"
                            z-index="12"
                          >
                            <u>View Booking</u>
                            <v-icon
                              style="
                                margin-left: 8px;
                                float: right;
                                align-self: right;
                              "
                              x-small
                              class="mr-1"
                            >
                              fas fa-chevron-right</v-icon
                            >
                          </v-btn></v-row
                        >
                      </v-col>
                    </v-card>
                  </v-col>
                </template>

                <!-- FINALISED BOOKING LENDER SIDE -->

                <template
                  v-if="
                    (placedView == 'active' &&
                      bookingsReceivedActive.length !== 0) ||
                    (placedView == 'all' && bookingsReceivedActive.length !== 0)
                  "
                >
                  <v-col cols="12">
                    <v-row class="my-4">
                      <h3>
                        Active Bookings ({{ bookingsReceivedActive.length }})
                      </h3>
                    </v-row>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    lg="3"
                    v-for="booking in bookingsReceivedActive"
                    :key="booking.id"
                  >
                    <v-card
                      :to="'/booking' + '/' + booking.id"
                      style="border-radius: 12px"
                      class="ma-2"
                      color="lgrey"
                      elevation="4"
                    >
                      <v-row class="card-head">
                        <v-col
                          style="padding: 8px; padding-left: 16px"
                          cols="10"
                        >
                          <h4>
                            <span class="white--text">Active booking</span>
                          </h4>
                        </v-col>
                        <v-col class="center" style="margin: 0px" cols="2">
                          <v-icon
                            @click.prevent="
                              showToast(
                                booking.borrowerName +
                                  ' is currently renting this item.'
                              )
                            "
                            style="
                              color: white;
                              float: right;
                              align-self: right;
                            "
                            small
                            class="mr-1"
                            >fas fa-info-circle</v-icon
                          >
                        </v-col>
                      </v-row>
                      <v-col cols="12 pa-6">
                        <v-row>
                          <v-col cols="6">
                            <v-card
                              height="125px"
                              width="125px"
                              class="card ma-3"
                              style="border-radius: 12px"
                            >
                              <v-img
                                :src="booking.images ? booking.images[0] : ''"
                                height="125px"
                                width="125px"
                              />
                            </v-card>
                          </v-col>
                          <v-col cols="6">
                            <div
                              class="ma-3 mt-md-4 mt-1 mt-sm-2 my-auto text-caption text-sm-body-2"
                            >
                              <div
                                class="ml-n3 my-1 my-md-4 black--text clip-booking"
                              >
                                <span class="font-weight-bold clip-booking">{{
                                  booking.itemName
                                }}</span>
                              </div>

                              <div class="ml-n3 my-1 my-md-4 my-2 clip-booking">
                                <span class="font-weight-bold clip-booking">
                                  {{ booking.startDate }} -
                                  {{ booking.endDate }}</span
                                >
                              </div>
                              <!-- <div class="ml-n3 my-1 my-md-4 my-2">
                                Length:
                                <span class="font-weight-bold">
                                  {{ booking.dateRange }} days</span
                                >
                              </div> -->

                              <div class="ml-n3 my-1 my-md-4 my-2 borrowername">
                                <span color="black"
                                  >Receivable:
                                  <span class="font-weight-bold">
                                    R{{ booking.lenderReceivable }}</span
                                  >
                                </span>
                              </div>
                              <div
                                class="ml-n3 my-1 my-md-4 my-2 borrowername"
                                style="cursor: pointer"
                              >
                                <v-avatar
                                  v-if="booking.borrowerAvatar"
                                  outline
                                  size="25"
                                  class="mr-1 mt-n2"
                                  style="margin-bottom: -3px"
                                >
                                  <v-img :src="booking.borrowerAvatar"></v-img>
                                </v-avatar>
                                <svg
                                  v-else
                                  viewBox="0 0 32 32"
                                  class="mr-1"
                                  xmlns="http://www.w3.org/2000/svg"
                                  :style="
                                    $vuetify.breakpoint.xsOnly
                                      ? 'height: 15px; width: 15px;'
                                      : '' && $vuetify.breakpoint.smAndDown
                                      ? 'height: 20px; width: 20px;'
                                      : 'height: 20px; width: 20px;' &&
                                        $vuetify.breakpoint.mdAndUp
                                      ? 'height: 20px; width: 20px;'
                                      : 'height: 20px; width: 20px;'
                                  "
                                  style="
                                    fill: currentcolor;
                                    margin-bottom: -3px;
                                  "
                                  aria-label="Profile button"
                                  role="presentation"
                                  focusable="false"
                                >
                                  <path
                                    d="m16 .7c-8.437 0-15.3 6.863-15.3 15.3s6.863 15.3 15.3 15.3 15.3-6.863 15.3-15.3-6.863-15.3-15.3-15.3zm0 28c-4.021 0-7.605-1.884-9.933-4.81a12.425 12.425 0 0 1 6.451-4.4 6.507 6.507 0 0 1 -3.018-5.49c0-3.584 2.916-6.5 6.5-6.5s6.5 2.916 6.5 6.5a6.513 6.513 0 0 1 -3.019 5.491 12.42 12.42 0 0 1 6.452 4.4c-2.328 2.925-5.912 4.809-9.933 4.809z"
                                  ></path>
                                </svg>
                                <span
                                  class="font-weight-bold borrowername text-subtitle-1"
                                >
                                  {{ booking.borrowerName }}
                                </span>
                              </div>
                            </div>
                          </v-col>
                        </v-row>
                        <v-row class="grid"
                          ><v-btn
                            rounded
                            :to="'/booking' + '/' + booking.id"
                            class="hidden mx-1 white app--text font-weight-medium"
                            z-index="12"
                          >
                            <u>View Booking</u>
                            <v-icon
                              style="
                                margin-left: 8px;
                                float: right;
                                align-self: right;
                              "
                              x-small
                              class="mr-1"
                            >
                              fas fa-chevron-right</v-icon
                            >
                          </v-btn></v-row
                        >
                      </v-col>
                    </v-card>
                  </v-col>
                </template>

                <template
                  v-if="
                    (recievedView == 'overdue' &&
                      bookingsReceivedOverDue.length !== 0) ||
                    (recievedView == 'all' &&
                      bookingsReceivedOverDue.length !== 0)
                  "
                >
                  <v-col cols="12">
                    <v-row class="my-4">
                      <h3>
                        Overdue Bookings ({{ bookingsReceivedOverDue.length }})
                      </h3>
                    </v-row>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    lg="3"
                    v-for="booking in bookingsReceivedOverDue"
                    :key="booking.id"
                  >
                    <v-card
                      :to="'/booking' + '/' + booking.id"
                      style="border-radius: 12px"
                      class="ma-2"
                      color="lgrey"
                      elevation="4"
                    >
                      <v-row class="card-head">
                        <v-col
                          style="padding: 8px; padding-left: 16px"
                          cols="10"
                        >
                          <h4>
                            <span class="white--text">Overdue booking</span>
                          </h4>
                        </v-col>
                        <v-col class="center" style="margin: 0px" cols="2">
                          <v-icon
                            @click.prevent="
                              showToast(
                                booking.borrowerName +
                                  ' has not returned your item in the designated time. The Strapp team has escalated the issue.'
                              )
                            "
                            style="
                              color: white;
                              float: right;
                              align-self: right;
                            "
                            small
                            class="mr-1"
                            >fas fa-info-circle</v-icon
                          >
                        </v-col>
                      </v-row>
                      <v-col cols="12 pa-6">
                        <v-row>
                          <v-col cols="6">
                            <v-card
                              height="125px"
                              width="125px"
                              class="card ma-3"
                              style="border-radius: 12px"
                            >
                              <v-img
                                :src="booking.images ? booking.images[0] : ''"
                                height="125px"
                                width="125px"
                              />
                            </v-card>
                          </v-col>
                          <v-col cols="6">
                            <div
                              class="ma-3 mt-md-4 mt-1 mt-sm-2 my-auto text-caption text-sm-body-2"
                            >
                              <div
                                class="ml-n3 my-1 my-md-4 black--text clip-booking"
                              >
                                <span class="font-weight-bold clip-booking">{{
                                  booking.itemName
                                }}</span>
                              </div>

                              <div class="ml-n3 my-1 my-md-4 my-2 clip-booking">
                                <span class="font-weight-bold clip-booking">
                                  {{ booking.startDate }} -
                                  {{ booking.endDate }}</span
                                >
                              </div>
                              <!-- <div class="ml-n3 my-1 my-md-4 my-2">
                                Length:
                                <span class="font-weight-bold">
                                  {{ booking.dateRange }} days</span
                                >
                              </div> -->

                              <div class="ml-n3 my-1 my-md-4 my-2 borrowername">
                                <span color="black"
                                  >Receivable:
                                  <span class="font-weight-bold">
                                    R{{ booking.lenderReceivable }}</span
                                  >
                                </span>
                              </div>
                              <div
                                class="ml-n3 my-1 my-md-4 my-2 borrowername"
                                style="cursor: pointer"
                              >
                                <v-avatar
                                  v-if="booking.borrowerAvatar"
                                  outline
                                  size="25"
                                  class="mr-1 mt-n2"
                                  style="margin-bottom: -3px"
                                >
                                  <v-img :src="booking.borrowerAvatar"></v-img>
                                </v-avatar>
                                <svg
                                  v-else-if="!booking.borrowerAvatar"
                                  viewBox="0 0 32 32"
                                  class="mr-1"
                                  xmlns="http://www.w3.org/2000/svg"
                                  :style="
                                    $vuetify.breakpoint.xsOnly
                                      ? 'height: 15px; width: 15px;'
                                      : '' && $vuetify.breakpoint.smAndDown
                                      ? 'height: 20px; width: 20px;'
                                      : 'height: 20px; width: 20px;' &&
                                        $vuetify.breakpoint.mdAndUp
                                      ? 'height: 20px; width: 20px;'
                                      : 'height: 20px; width: 20px;'
                                  "
                                  style="
                                    fill: currentcolor;
                                    margin-bottom: -3px;
                                  "
                                  aria-label="Profile button"
                                  role="presentation"
                                  focusable="false"
                                >
                                  <path
                                    d="m16 .7c-8.437 0-15.3 6.863-15.3 15.3s6.863 15.3 15.3 15.3 15.3-6.863 15.3-15.3-6.863-15.3-15.3-15.3zm0 28c-4.021 0-7.605-1.884-9.933-4.81a12.425 12.425 0 0 1 6.451-4.4 6.507 6.507 0 0 1 -3.018-5.49c0-3.584 2.916-6.5 6.5-6.5s6.5 2.916 6.5 6.5a6.513 6.513 0 0 1 -3.019 5.491 12.42 12.42 0 0 1 6.452 4.4c-2.328 2.925-5.912 4.809-9.933 4.809z"
                                  ></path>
                                </svg>
                                <span
                                  class="font-weight-bold borrowername text-subtitle-1"
                                >
                                  {{ booking.borrowerName }}
                                </span>
                              </div>
                            </div>
                          </v-col>
                        </v-row>
                        <v-row class="grid"
                          ><v-btn
                            rounded
                            :to="'/booking' + '/' + booking.id"
                            class="hidden mx-1 white app--text font-weight-medium"
                            z-index="12"
                          >
                            <u>View Booking</u>
                            <v-icon
                              style="
                                margin-left: 8px;
                                float: right;
                                align-self: right;
                              "
                              x-small
                              class="mr-1"
                            >
                              fas fa-chevron-right</v-icon
                            >
                          </v-btn></v-row
                        >
                      </v-col>
                    </v-card>
                  </v-col>
                </template>

                <!-- COMPLETED BOKINGS PLACED -->

                <template
                  v-if="recievedView == 'past' || recievedView == 'all'"
                >
                  <v-col cols="12">
                    <v-row class="mb-3">
                      <h3
                        v-if="
                          bookingsReceivedReturned.length > 0 ||
                          bookingsReceivedCompleted.length > 0 ||
                          bookingsReceivedCancelled.length > 0
                        "
                      >
                        Past bookings
                      </h3>
                    </v-row>
                  </v-col>

                  <v-col
                    cols="12"
                    sm="6"
                    lg="3"
                    v-for="booking in bookingsReceivedReturned"
                    :key="booking.id"
                    style="padding: 0px !important"
                  >
                    <v-card
                      :to="'/booking' + '/' + booking.id"
                      style="border-radius: 12px"
                      class="pa-6 ma-2"
                      color="lgrey"
                      elevation="4"
                    >
                      <v-row>
                        <v-col cols="12">
                          <v-row class="mx-1" style="text-align: left">
                            <h4>
                              <span class="black--text">Returned Booking</span>
                            </h4>
                          </v-row>
                          <br />
                          <p class="clip-booking">{{ booking.itemName }}</p>
                          <v-row>
                            <v-col style="text-align: left" cols="5">
                              {{ booking.endDate }}
                            </v-col>
                            <v-col
                              style="text-align: right; padding-left: 0px"
                              cols="7"
                            >
                              R{{ booking.rentalFee }}.00 ({{
                                booking.dateRange
                              }}
                              Day/s)
                            </v-col>
                          </v-row>

                          <!-- <rating-dialog
                            class="center"
                            style="margin-top: 16px; align-items: center"
                            :booking="booking"
                            :showBtn="true"
                            :open="false"
                          >
                          </rating-dialog> -->

                          <v-row class="grid">
                            <v-btn
                              class="appbutton white--text font-weight-medium"
                              :v-bind="size"
                              rounded
                              :to="'/booking' + '/' + booking.id"
                            >
                              <v-img
                                width="20px"
                                height="20px"
                                class="mr-3"
                                :src="
                                  require('@/assets/fontawesome/clipboard-list-check-duotone.svg')
                                "
                              />
                              <span class="text-caption">Leave Review</span>
                            </v-btn>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>

                  <v-col
                    cols="12"
                    sm="6"
                    lg="3"
                    v-for="booking in bookingsReceivedCancelled"
                    :key="booking.id"
                    style="padding: 0px !important"
                  >
                    <v-card
                      :to="'/booking' + '/' + booking.id"
                      style="border-radius: 12px"
                      class="pa-6 ma-2"
                      color="lgrey"
                      elevation="4"
                    >
                      <v-row>
                        <v-col cols="12">
                          <v-row class="mx-1" style="text-align: left">
                            <h4>
                              <span class="black--text">Cancelled Booking</span>
                            </h4>
                          </v-row>
                          <br />
                          <p class="clip-booking">{{ booking.itemName }}</p>
                          <v-row>
                            <v-col style="text-align: left" cols="5">
                              {{ booking.endDate }}
                            </v-col>
                            <v-col
                              style="text-align: right; padding-left: 0px"
                              cols="7"
                            >
                              R{{ booking.rentalFee }}.00 ({{
                                booking.dateRange
                              }}
                              Day/s)
                            </v-col>
                          </v-row>
                          <v-row class="grid"
                            ><v-btn
                              rounded
                              :to="'/booking' + '/' + booking.id"
                              class="hidden mx-1 white app--text font-weight-medium"
                              z-index="12"
                            >
                              <u>View Booking</u>
                              <v-icon
                                style="
                                  margin-left: 8px;
                                  float: right;
                                  align-self: right;
                                "
                                x-small
                                class="mr-1"
                              >
                                fas fa-chevron-right</v-icon
                              >
                            </v-btn></v-row
                          >
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>

                  <v-col
                    cols="12"
                    sm="6"
                    lg="3"
                    v-for="booking in bookingsReceivedCompleted"
                    :key="booking.id"
                    style="padding: 0px !important"
                  >
                    <v-card
                      :to="'/booking' + '/' + booking.id"
                      style="border-radius: 12px"
                      class="pa-6 ma-2"
                      color="lgrey"
                      elevation="4"
                    >
                      <v-row>
                        <v-col cols="12">
                          <v-row class="mx-1" style="text-align: left">
                            <h4>
                              <span class="black--text">Completed Booking</span>
                            </h4>
                          </v-row>
                          <br />
                          <p class="clip-booking">{{ booking.itemName }}</p>
                          <v-row>
                            <v-col style="text-align: left" cols="5">
                              {{ booking.endDate }}
                            </v-col>
                            <v-col
                              style="text-align: right; padding-left: 0px"
                              cols="7"
                            >
                              R{{ booking.rentalFee }}.00 ({{
                                booking.dateRange
                              }}
                              Day/s)
                            </v-col>
                          </v-row>
                          <v-row class="grid"
                            ><v-btn
                              rounded
                              :to="'/booking' + '/' + booking.id"
                              class="hidden mx-1 white app--text font-weight-medium"
                              z-index="12"
                            >
                              <u>View Booking</u>
                              <v-icon
                                style="
                                  margin-left: 8px;
                                  float: right;
                                  align-self: right;
                                "
                                x-small
                                class="mr-1"
                              >
                                fas fa-chevron-right</v-icon
                              >
                            </v-btn></v-row
                          >
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </template>
              </v-row>
            </div>
          </v-col>
        </template>

        <template v-if="tabState === 'bookings-placed'">
          <v-row
            v-if="
              bookingsPlaced.length < 1 &&
              bookingsPlacedCompleted < 1 &&
              bookingsPlacedReturned < 1
            "
            class="mb-2 grid mt-5"
          >
            <p class="text-h4">You haven't placed any bookings yet.</p>
            You can browse for rentals you like by clicking the button below.
            <v-img
              width="150px"
              height="150px"
              :src="require('@/assets/svgs/message-10.svg')"
            />
            <v-btn
              class="appbutton mx-1 mt-3 white--text font-weight-medium"
              rounded
              to="/search"
              color="accent"
              z-index="12"
              :class="$vuetify.breakpoint.mdAndUp ? '' : 'mt-3'"
            >
              <v-img
                class="mr-2"
                :style="
                  $vuetify.breakpoint.xsOnly
                    ? 'height: 10px; width: 10px;'
                    : '' && $vuetify.breakpoint.smAndDown
                    ? 'height: 18px; width: 18px;'
                    : 'height: 18px; width: 18px;' &&
                      $vuetify.breakpoint.mdAndUp
                    ? 'height: 18px; width: 18px;'
                    : 'height: 12px; width: 12px;'
                "
                :src="
                  require('@/assets/fontawesome/magnifying-glass-solid.svg')
                "
              />Browse
            </v-btn>
          </v-row>
          <v-col v-else>
            <v-row class="grid mx-4">
              <h4>Your requests to borrow others items will show up here</h4>
            </v-row>

            <v-row>
              <v-col cols="11" class="mt-6 d-flex justify-space-between">
                <div class="hidden-sm-and-down">
                  <v-btn
                    small
                    @click="placedView = 'all'"
                    :class="placedView == 'all' ? 'selected' : 'not-selected'"
                    text
                  >
                    All</v-btn
                  >
                  <v-btn
                    @click="placedView = 'pending'"
                    small
                    :class="
                      placedView == 'pending' ? 'selected' : 'not-selected'
                    "
                    text
                    v-if="bookingsPlacedPending.length !== 0"
                  >
                    pending acceptance</v-btn
                  >
                  <v-btn
                    @click="placedView = 'awaiting-payment'"
                    small
                    :class="
                      placedView == 'awaiting-payment'
                        ? 'selected'
                        : 'not-selected'
                    "
                    v-if="bookingsPlacedAwaitingPayment.length !== 0"
                    text
                  >
                    Waiting for payment</v-btn
                  >
                  <v-btn
                    @click="placedView = 'finalised'"
                    small
                    :class="
                      placedView == 'finalised' ? 'selected' : 'not-selected'
                    "
                    v-if="bookingsPlacedFinalised.length !== 0"
                    text
                  >
                    Finalised</v-btn
                  >
                  <v-btn
                    small
                    @click="placedView = 'active'"
                    :color="placedView == 'active' ? 'accent' : ''"
                    v-if="bookingsPlacedActive.length !== 0"
                    :class="
                      placedView == 'active' ? 'selected' : 'not-selected'
                    "
                    text
                  >
                    Active</v-btn
                  >

                  <v-btn
                    small
                    @click="placedView = 'active'"
                    :color="placedView == 'active' ? 'accent' : ''"
                    v-if="bookingsPlacedPendingReturn.length !== 0"
                    :class="
                      placedView == 'pending-return'
                        ? 'selected'
                        : 'not-selected'
                    "
                    text
                  >
                    pending return</v-btn
                  >

                  <!-- <v-btn
                    small
                    @click="placedView = 'past'"
                    :color="placedView == 'past' ? 'accent' : ''"
                    v-if="bookingsPlacedPendingReturn.length !== 0"
                    :class="
                      placedView == 'past'
                        ? 'selected'
                        : 'not-selected'
                    "
                    text
                  >
                    past </v-btn
                  > -->
                </div>

                <div>
                  <v-select
                    v-model="placedView"
                    label="Filter booking status"
                    :items="placedBookingStates"
                    class="round hidden-md-and-up"
                    outlined
                    small
                    color="rgb(34, 34, 34)"
                  />
                </div>

                <v-spacer />

                <div>
                  <v-switch
                    v-model="placedTableSwtich"
                    class="ma-2 ml-2"
                    inset
                    color="accent"
                    small
                    :label="
                      placedTableSwtich == true ? 'Card View' : 'Table View'
                    "
                  ></v-switch>
                </div>
              </v-col>
            </v-row>

            <v-row v-if="placedTableSwtich == true">
              <v-col cols="12">
                <bookings-placed-table
                  :bookingsPlaced="bookingsPlaced"
                  class="mt-8"
                />
              </v-col>
            </v-row>

            <v-row v-if="placedTableSwtich == false">
              <div v-if="placedView == 'all'">
                <v-col
                  cols="12"
                  md="6"
                  lg="6"
                  v-for="booking in bookingsPlacedIssue"
                  :key="booking.id"
                >
                  <v-card
                    :to="'/booking' + '/' + booking.id"
                    style="border-radius: 12px"
                    class="ma-2"
                    color="lgrey"
                    elevation="4"
                  >
                    <v-row class="card-head">
                      <v-col style="padding: 8px; padding-left: 16px" cols="10">
                        <h4>
                          <span class="white--text">Booking Issue</span>
                        </h4>
                      </v-col>
                      <v-col class="center" style="margin: 0px" cols="2">
                        <v-icon
                          @click.prevent="
                            showToast(
                              'A support ticket has been logged with our helpdesk related to this booking.'
                            )
                          "
                          style="color: white; float: right; align-self: right"
                          small
                          class="mr-1"
                          >fas fa-info-circle</v-icon
                        >
                      </v-col>
                    </v-row>
                    <v-col cols="12 pa-6">
                      <v-row>
                        <v-col cols="6">
                          <v-card
                            height="125px"
                            width="125px"
                            class="card ma-3"
                            style="border-radius: 12px"
                          >
                            <v-img
                              :src="booking.images ? booking.images[0] : ''"
                              height="125px"
                              width="125px"
                            />
                          </v-card>
                        </v-col>
                        <v-col cols="6">
                          <div
                            class="ma-3 mt-md-4 mt-1 mt-sm-2 my-auto text-caption text-sm-body-2"
                          >
                            <div
                              class="ml-n3 my-1 my-md-4 black--text clip-booking"
                            >
                              <span class="font-weight-bold">{{
                                booking.itemName
                              }}</span>
                            </div>

                            <div class="ml-n3 my-1 my-md-4 my-2 clip-booking">
                              <span class="font-weight-bold">
                                {{ booking.startDate }} -
                                {{ booking.endDate }}</span
                              >
                            </div>
                            <!-- <div class="ml-n3 my-1 my-md-4 my-2">
                              Length:
                              <span class="font-weight-bold">
                                {{ booking.dateRange }} days</span
                              >
                            </div> -->

                            <div class="ml-n3 my-1 my-md-4 my-2">
                              Total:
                              <span class="font-weight-bold borrowername">
                                R{{ booking.total }}</span
                              >
                            </div>

                            <div
                              class="ml-n3 my-1 my-md-4 my-2 borrowername"
                              style="cursor: pointer"
                            >
                              <v-avatar
                                v-if="booking.lenderAvatar"
                                outline
                                size="25"
                                class="mr-1 mt-n2"
                                style="margin-bottom: -3px"
                              >
                                <v-img :src="booking.lenderAvatar"></v-img>
                              </v-avatar>
                              <svg
                                v-else-if="!booking.lenderAvatar"
                                viewBox="0 0 32 32"
                                class="mr-1"
                                xmlns="http://www.w3.org/2000/svg"
                                :style="
                                  $vuetify.breakpoint.xsOnly
                                    ? 'height: 15px; width: 15px;'
                                    : '' && $vuetify.breakpoint.smAndDown
                                    ? 'height: 20px; width: 20px;'
                                    : 'height: 20px; width: 20px;' &&
                                      $vuetify.breakpoint.mdAndUp
                                    ? 'height: 20px; width: 20px;'
                                    : 'height: 20px; width: 20px;'
                                "
                                style="fill: currentcolor; margin-bottom: -3px"
                                aria-label="Profile button"
                                role="presentation"
                                focusable="false"
                              >
                                <path
                                  d="m16 .7c-8.437 0-15.3 6.863-15.3 15.3s6.863 15.3 15.3 15.3 15.3-6.863 15.3-15.3-6.863-15.3-15.3-15.3zm0 28c-4.021 0-7.605-1.884-9.933-4.81a12.425 12.425 0 0 1 6.451-4.4 6.507 6.507 0 0 1 -3.018-5.49c0-3.584 2.916-6.5 6.5-6.5s6.5 2.916 6.5 6.5a6.513 6.513 0 0 1 -3.019 5.491 12.42 12.42 0 0 1 6.452 4.4c-2.328 2.925-5.912 4.809-9.933 4.809z"
                                ></path>
                              </svg>
                              <span
                                class="font-weight-bold borrowername text-subtitle-1"
                              >
                                {{ booking.lenderName }}
                              </span>
                            </div>
                          </div>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-card>
                </v-col>
              </div>

              <template
                v-if="
                  (placedView == 'awaiting-payment' &&
                    bookingsPlacedAwaitingPayment.length !== 0) ||
                  (placedView == 'all' &&
                    bookingsPlacedAwaitingPayment.length !== 0)
                "
              >
                <v-col cols="12">
                  <v-row class="my-4">
                    <h3>
                      Awaiting Payment ({{
                        bookingsPlacedAwaitingPayment.length
                      }})
                    </h3>
                  </v-row>
                </v-col>

                <v-col
                  cols="12"
                  sm="6"
                  lg="3"
                  v-for="booking in bookingsPlacedAwaitingPayment"
                  :key="booking.id"
                >
                  <v-card
                    style="border-radius: 12px"
                    class="ma-2"
                    color="lgrey"
                    elevation="4"
                    :to="'/booking' + '/' + booking.id"
                  >
                    <v-row class="card-head">
                      <v-col style="padding: 8px; padding-left: 16px" cols="10">
                        <h4>
                          <span class="white--text">Awaiting Payment</span>
                        </h4>
                      </v-col>
                      <v-col class="center" style="margin: 0px" cols="2">
                        <v-icon
                          @click.prevent="
                            showToast(
                              booking.lenderName +
                                ' has approved your booking request and is waiting for payment. Please follow the prompts in the booking to make payment.'
                            )
                          "
                          style="color: white; float: right; align-self: right"
                          small
                          class="mr-1"
                          >fas fa-info-circle</v-icon
                        >
                      </v-col>
                    </v-row>
                    <v-col cols="12 pa-6">
                      <v-row>
                        <v-col cols="6">
                          <v-card
                            height="125px"
                            width="125px"
                            class="card ma-3"
                            style="border-radius: 12px"
                          >
                            <v-img
                              :src="booking.images ? booking.images[0] : ''"
                              height="125px"
                              width="125px"
                            />
                          </v-card>
                        </v-col>
                        <v-col cols="6">
                          <div
                            class="ma-3 mt-md-4 mt-1 mt-sm-2 my-auto text-caption text-sm-body-2"
                          >
                            <div
                              class="ml-n3 my-1 my-md-4 black--text clip-booking"
                            >
                              <span class="font-weight-bold clip-booking">{{
                                booking.itemName
                              }}</span>
                            </div>

                            <div class="ml-n3 my-1 my-md-4 my-2 clip-booking">
                              <span class="font-weight-bold">
                                {{ booking.startDate }} -
                                {{ booking.endDate }}</span
                              >
                            </div>
                            <!-- <div class="ml-n3 my-1 my-md-4 my-2">
                              Length:
                              <span class="font-weight-bold">
                                {{ booking.dateRange }} days</span
                              >
                            </div> -->
                            <div class="ml-n3 my-1 my-md-4 my-2 borrowername">
                              Total:
                              <span class="font-weight-bold">
                                R{{ booking.total }}</span
                              >
                            </div>
                            <div
                              class="ml-n3 my-1 my-md-4 my-2 borrowername"
                              style="cursor: pointer"
                            >
                              <v-avatar
                                v-if="booking.lenderAvatar"
                                outline
                                size="25"
                                class="mr-1 mt-n2"
                                style="margin-bottom: -3px"
                              >
                                <v-img :src="booking.lenderAvatar"></v-img>
                              </v-avatar>
                              <svg
                                v-else-if="!booking.lenderAvatar"
                                viewBox="0 0 32 32"
                                class="mr-1"
                                xmlns="http://www.w3.org/2000/svg"
                                :style="
                                  $vuetify.breakpoint.xsOnly
                                    ? 'height: 15px; width: 15px;'
                                    : '' && $vuetify.breakpoint.smAndDown
                                    ? 'height: 20px; width: 20px;'
                                    : 'height: 20px; width: 20px;' &&
                                      $vuetify.breakpoint.mdAndUp
                                    ? 'height: 20px; width: 20px;'
                                    : 'height: 20px; width: 20px;'
                                "
                                style="fill: currentcolor; margin-bottom: -3px"
                                aria-label="Profile button"
                                role="presentation"
                                focusable="false"
                              >
                                <path
                                  d="m16 .7c-8.437 0-15.3 6.863-15.3 15.3s6.863 15.3 15.3 15.3 15.3-6.863 15.3-15.3-6.863-15.3-15.3-15.3zm0 28c-4.021 0-7.605-1.884-9.933-4.81a12.425 12.425 0 0 1 6.451-4.4 6.507 6.507 0 0 1 -3.018-5.49c0-3.584 2.916-6.5 6.5-6.5s6.5 2.916 6.5 6.5a6.513 6.513 0 0 1 -3.019 5.491 12.42 12.42 0 0 1 6.452 4.4c-2.328 2.925-5.912 4.809-9.933 4.809z"
                                ></path>
                              </svg>
                              <span
                                class="font-weight-bold borrowername text-subtitle-1"
                              >
                                {{ booking.lenderName }}
                              </span>
                            </div>
                          </div>
                        </v-col>
                      </v-row>
                      <v-btn
                        large
                        block
                        class="mt-2 mb-0 appbutton rounded-lg white--text font-weight-medium text-body-2"
                        v-if="!verified"
                        color="#B22AF0"
                        z-index="12"
                        :to="'/booking' + '/' + booking.id"
                        >Verify and Pay</v-btn
                      >
                      <v-btn
                        v-if="verified"
                        large
                        block
                        class="mt-2 mb-0 appbutton rounded-lg white--text font-weight-medium text-body-2"
                        color="#B22AF0"
                        z-index="12"
                        :to="'/booking' + '/' + booking.id"
                      >
                        Pay</v-btn
                      >
                    </v-col>
                  </v-card>
                </v-col>
              </template>

              <template
                v-if="placedView == 'return-due' || placedView == 'all'"
              >
                <v-col
                  cols="12"
                  sm="6"
                  lg="3"
                  v-for="booking in bookingsPlacedPendingReturn"
                  :key="booking.id"
                >
                  <v-card
                    style="border-radius: 12px"
                    class="ma-2"
                    color="lgrey"
                    elevation="4"
                    :to="'/booking' + '/' + booking.id"
                  >
                    <v-row class="card-head">
                      <v-col style="padding: 8px; padding-left: 16px" cols="10">
                        <h4>
                          <span class="white--text">Return Due</span>
                        </h4>
                      </v-col>
                      <v-col class="center" style="margin: 0px" cols="2">
                        <v-icon
                          @click.prevent="
                            showToast(
                              'Your rental period with ' +
                                booking.lenderName +
                                ' has expired. If you have not yet returned the item, please do so. Once ' +
                                booking.lenderName +
                                ' has confirmed the return you may follow the steps to receive your deposit back.'
                            )
                          "
                          style="color: white; float: right; align-self: right"
                          small
                          class="mr-1"
                          >fas fa-info-circle</v-icon
                        >
                      </v-col>
                    </v-row>
                    <v-col cols="12 pa-6">
                      <v-row>
                        <v-col cols="6">
                          <v-card
                            height="125px"
                            width="125px"
                            class="card ma-3"
                            style="border-radius: 12px"
                          >
                            <v-img
                              :src="booking.images ? booking.images[0] : ''"
                              height="125px"
                              width="125px"
                            />
                          </v-card>
                        </v-col>
                        <v-col cols="6">
                          <div
                            class="ma-3 mt-md-4 mt-1 mt-sm-2 my-auto text-caption text-sm-body-2"
                          >
                            <div
                              class="ml-n3 my-1 my-md-4 black--text clip-booking"
                            >
                              <span class="font-weight-bold">{{
                                booking.itemName
                              }}</span>
                            </div>

                            <div class="ml-n3 my-1 my-md-4 my-2 clip-booking">
                              <span class="font-weight-bold">
                                {{ booking.startDate }} -
                                {{ booking.endDate }}</span
                              >
                            </div>
                            <!-- <div class="ml-n3 my-1 my-md-4 my-2">
                              Length:
                              <span class="font-weight-bold">
                                {{ booking.dateRange }} days</span
                              >
                            </div> -->

                            <div class="ml-n3 my-1 my-md-4 my-2 borrowername">
                              Total:
                              <span class="font-weight-bold">
                                R{{ booking.total }}</span
                              >
                            </div>

                            <div
                              class="ml-n3 my-1 my-md-4 my-2 borrowername"
                              style="cursor: pointer"
                            >
                              <v-avatar
                                v-if="booking.lenderAvatar"
                                outline
                                size="25"
                                class="mr-1 mt-n2"
                                style="margin-bottom: -3px"
                              >
                                <v-img :src="booking.lenderAvatar"></v-img>
                              </v-avatar>
                              <svg
                                v-else-if="!booking.lenderAvatar"
                                viewBox="0 0 32 32"
                                class="mr-1"
                                xmlns="http://www.w3.org/2000/svg"
                                :style="
                                  $vuetify.breakpoint.xsOnly
                                    ? 'height: 15px; width: 15px;'
                                    : '' && $vuetify.breakpoint.smAndDown
                                    ? 'height: 20px; width: 20px;'
                                    : 'height: 20px; width: 20px;' &&
                                      $vuetify.breakpoint.mdAndUp
                                    ? 'height: 20px; width: 20px;'
                                    : 'height: 20px; width: 20px;'
                                "
                                style="fill: currentcolor; margin-bottom: -3px"
                                aria-label="Profile button"
                                role="presentation"
                                focusable="false"
                              >
                                <path
                                  d="m16 .7c-8.437 0-15.3 6.863-15.3 15.3s6.863 15.3 15.3 15.3 15.3-6.863 15.3-15.3-6.863-15.3-15.3-15.3zm0 28c-4.021 0-7.605-1.884-9.933-4.81a12.425 12.425 0 0 1 6.451-4.4 6.507 6.507 0 0 1 -3.018-5.49c0-3.584 2.916-6.5 6.5-6.5s6.5 2.916 6.5 6.5a6.513 6.513 0 0 1 -3.019 5.491 12.42 12.42 0 0 1 6.452 4.4c-2.328 2.925-5.912 4.809-9.933 4.809z"
                                ></path>
                              </svg>
                              <span
                                class="font-weight-bold borrowername text-subtitle-1"
                              >
                                {{ booking.lenderName }}
                              </span>
                            </div>
                          </div>
                        </v-col>
                      </v-row>
                      <v-row class="grid"
                        ><v-btn
                          rounded
                          :to="'/booking' + '/' + booking.id"
                          class="hidden mx-1 white app--text font-weight-medium"
                          z-index="12"
                        >
                          <u>View Booking</u>
                          <v-icon
                            style="
                              margin-left: 8px;
                              float: right;
                              align-self: right;
                            "
                            x-small
                            class="mr-1"
                          >
                            fas fa-chevron-right</v-icon
                          >
                        </v-btn></v-row
                      >
                    </v-col>
                  </v-card>
                </v-col>
              </template>

              <template
                v-if="
                  (placedView == 'finalised' &&
                    bookingsPlacedFinalised.length !== 0) ||
                  (placedView == 'all' && bookingsPlacedFinalised.length !== 0)
                "
              >
                <v-col cols="12">
                  <v-row class="my-4">
                    <h3>
                      Finalised bookings ({{ bookingsPlacedFinalised.length }})
                    </h3>
                  </v-row>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  lg="3"
                  v-for="booking in bookingsPlacedFinalised"
                  :key="booking.id"
                >
                  <v-card
                    style="border-radius: 12px"
                    class="ma-2"
                    color="lgrey"
                    elevation="4"
                    :to="'/booking' + '/' + booking.id"
                  >
                    <v-row class="card-head">
                      <v-col style="padding: 8px; padding-left: 16px" cols="10">
                        <h4>
                          <span class="white--text">Finalised Booking</span>
                        </h4>
                      </v-col>
                      <v-col class="center" style="margin: 0px" cols="2">
                        <v-icon
                          @click.prevent="
                            showToast('Your booking has been finalised.')
                          "
                          style="color: white; float: right; align-self: right"
                          small
                          class="mr-1"
                          >fas fa-info-circle</v-icon
                        >
                      </v-col>
                    </v-row>
                    <v-col cols="12 pa-6">
                      <v-row>
                        <v-col cols="6">
                          <v-card
                            height="125px"
                            width="125px"
                            class="card ma-3"
                            style="border-radius: 12px"
                          >
                            <v-img
                              :src="booking.images ? booking.images[0] : ''"
                              height="125px"
                              width="125px"
                            />
                          </v-card>
                        </v-col>
                        <v-col cols="6">
                          <div
                            class="ma-3 mt-md-4 mt-1 mt-sm-2 my-auto text-caption text-sm-body-2"
                          >
                            <div
                              class="ml-n3 my-1 my-md-4 black--text clip-booking"
                            >
                              <span class="font-weight-bold">{{
                                booking.itemName
                              }}</span>
                            </div>

                            <div class="ml-n3 my-1 my-md-4 my-2 clip-booking">
                              <span class="font-weight-bold">
                                {{ booking.startDate }} -
                                {{ booking.endDate }}</span
                              >
                            </div>
                            <!-- <div class="ml-n3 my-1 my-md-4 my-2">
                              Length:
                              <span class="font-weight-bold">
                                {{ booking.dateRange }} days</span
                              >
                            </div> -->
                            <div class="ml-n3 my-1 my-md-4 my-2 borrowername">
                              Total:
                              <span class="font-weight-bold">
                                R{{ booking.total }}</span
                              >
                            </div>

                            <div
                              class="ml-n3 my-1 my-md-4 my-2 borrowername"
                              style="cursor: pointer"
                            >
                              <v-avatar
                                v-if="booking.lenderAvatar"
                                outline
                                size="25"
                                class="mr-1 mt-n2"
                                style="margin-bottom: -3px"
                              >
                                <v-img :src="booking.lenderAvatar"></v-img>
                              </v-avatar>
                              <svg
                                v-else-if="!booking.lenderAvatar"
                                viewBox="0 0 32 32"
                                class="mr-1"
                                xmlns="http://www.w3.org/2000/svg"
                                :style="
                                  $vuetify.breakpoint.xsOnly
                                    ? 'height: 15px; width: 15px;'
                                    : '' && $vuetify.breakpoint.smAndDown
                                    ? 'height: 20px; width: 20px;'
                                    : 'height: 20px; width: 20px;' &&
                                      $vuetify.breakpoint.mdAndUp
                                    ? 'height: 20px; width: 20px;'
                                    : 'height: 20px; width: 20px;'
                                "
                                style="fill: currentcolor; margin-bottom: -3px"
                                aria-label="Profile button"
                                role="presentation"
                                focusable="false"
                              >
                                <path
                                  d="m16 .7c-8.437 0-15.3 6.863-15.3 15.3s6.863 15.3 15.3 15.3 15.3-6.863 15.3-15.3-6.863-15.3-15.3-15.3zm0 28c-4.021 0-7.605-1.884-9.933-4.81a12.425 12.425 0 0 1 6.451-4.4 6.507 6.507 0 0 1 -3.018-5.49c0-3.584 2.916-6.5 6.5-6.5s6.5 2.916 6.5 6.5a6.513 6.513 0 0 1 -3.019 5.491 12.42 12.42 0 0 1 6.452 4.4c-2.328 2.925-5.912 4.809-9.933 4.809z"
                                ></path>
                              </svg>
                              <span
                                class="font-weight-bold borrowername text-subtitle-1"
                              >
                                {{ booking.lenderName }}
                              </span>
                            </div>
                          </div>
                        </v-col>
                      </v-row>
                      <v-row class="grid"
                        ><v-btn
                          rounded
                          :to="'/booking' + '/' + booking.id"
                          class="hidden mx-1 white app--text font-weight-medium"
                          z-index="12"
                        >
                          <u>View Booking</u>
                          <v-icon
                            style="
                              margin-left: 8px;
                              float: right;
                              align-self: right;
                            "
                            x-small
                            class="mr-1"
                          >
                            fas fa-chevron-right</v-icon
                          >
                        </v-btn></v-row
                      >
                    </v-col>
                  </v-card>
                </v-col>
              </template>

              <template
                v-if="
                  (placedView == 'pending' &&
                    bookingsPlacedPending.length !== 0) ||
                  (placedView == 'all' && bookingsPlacedPending.length !== 0)
                "
              >
                <v-col cols="12">
                  <v-row class="my-4">
                    <h3>
                      Pending Bookings ({{ bookingsPlacedPending.length }})
                    </h3>
                  </v-row>
                </v-col>

                <v-col
                  cols="12"
                  sm="6"
                  lg="3"
                  v-for="booking in bookingsPlacedPending"
                  :key="booking.id"
                >
                  <v-card
                    style="border-radius: 12px"
                    class="ma-2"
                    color="lgrey"
                    elevation="4"
                    :to="'/booking' + '/' + booking.id"
                  >
                    <v-row class="card-head">
                      <v-col style="padding: 8px; padding-left: 16px" cols="10">
                        <h4>
                          <span class="white--text">Pending booking</span>
                        </h4>
                      </v-col>
                      <v-col class="center" style="margin: 0px" cols="2">
                        <v-icon
                          @click.prevent="
                            showToast(
                              'You have requested to book this item. If ' +
                                booking.lenderName +
                                ' accepts this request you will be prompted to make a payment.'
                            )
                          "
                          style="color: white; float: right; align-self: right"
                          small
                          class="mr-1"
                          >fas fa-info-circle</v-icon
                        >
                      </v-col>
                    </v-row>
                    <v-col cols="12 pa-6">
                      <v-row>
                        <v-col cols="6">
                          <v-card
                            height="125px"
                            width="125px"
                            class="card ma-3"
                            style="border-radius: 12px"
                          >
                            <v-img
                              :src="booking.images ? booking.images[0] : ''"
                              height="125px"
                              width="125px"
                            />
                          </v-card>
                        </v-col>
                        <v-col cols="6">
                          <div
                            class="ma-3 mt-md-4 mt-1 mt-sm-2 my-auto text-caption text-sm-body-2"
                          >
                            <div
                              class="ml-n3 my-1 my-md-4 black--text clip-booking"
                            >
                              <span class="font-weight-bold">{{
                                booking.itemName
                              }}</span>
                            </div>

                            <div class="ml-n3 my-1 my-md-4 my-2 clip-booking">
                              <span class="font-weight-bold clip-booking">
                                {{ booking.startDate }} -
                                {{ booking.endDate }}</span
                              >
                            </div>
                            <!-- <div class="ml-n3 my-1 my-md-4 my-2">
                              Length:
                              <span class="font-weight-bold">
                                {{ booking.dateRange }} days</span
                              >
                            </div> -->

                            <div class="ml-n3 my-1 my-md-4 my-2 borrowername">
                              Total:
                              <span class="font-weight-bold">
                                R{{ booking.total }}</span
                              >
                            </div>

                            <div
                              class="ml-n3 my-1 my-md-4 my-2 borrowername"
                              style="cursor: pointer"
                            >
                              <v-avatar
                                v-if="booking.lenderAvatar"
                                outline
                                size="25"
                                class="mr-1 mt-n2"
                                style="margin-bottom: -3px"
                              >
                                <v-img :src="booking.lenderAvatar"></v-img>
                              </v-avatar>
                              <svg
                                v-else-if="!booking.lenderAvatar"
                                viewBox="0 0 32 32"
                                class="mr-1"
                                xmlns="http://www.w3.org/2000/svg"
                                :style="
                                  $vuetify.breakpoint.xsOnly
                                    ? 'height: 15px; width: 15px;'
                                    : '' && $vuetify.breakpoint.smAndDown
                                    ? 'height: 20px; width: 20px;'
                                    : 'height: 20px; width: 20px;' &&
                                      $vuetify.breakpoint.mdAndUp
                                    ? 'height: 20px; width: 20px;'
                                    : 'height: 20px; width: 20px;'
                                "
                                style="fill: currentcolor; margin-bottom: -3px"
                                aria-label="Profile button"
                                role="presentation"
                                focusable="false"
                              >
                                <path
                                  d="m16 .7c-8.437 0-15.3 6.863-15.3 15.3s6.863 15.3 15.3 15.3 15.3-6.863 15.3-15.3-6.863-15.3-15.3-15.3zm0 28c-4.021 0-7.605-1.884-9.933-4.81a12.425 12.425 0 0 1 6.451-4.4 6.507 6.507 0 0 1 -3.018-5.49c0-3.584 2.916-6.5 6.5-6.5s6.5 2.916 6.5 6.5a6.513 6.513 0 0 1 -3.019 5.491 12.42 12.42 0 0 1 6.452 4.4c-2.328 2.925-5.912 4.809-9.933 4.809z"
                                ></path>
                              </svg>
                              <span
                                class="font-weight-bold borrowername text-subtitle-1"
                              >
                                {{ booking.lenderName }}
                              </span>
                            </div>
                          </div>
                        </v-col>
                      </v-row>
                      <v-row class="grid"
                        ><v-btn
                          rounded
                          :to="'/booking' + '/' + booking.id"
                          class="hidden mx-1 white app--text font-weight-medium"
                          z-index="12"
                        >
                          <u>View Booking</u>
                          <v-icon
                            style="
                              margin-left: 8px;
                              float: right;
                              align-self: right;
                            "
                            x-small
                            class="mr-1"
                          >
                            fas fa-chevron-right</v-icon
                          >
                        </v-btn></v-row
                      >
                    </v-col>
                  </v-card>
                </v-col>
              </template>

              <v-row
                v-if="
                  (placedView == 'active' &&
                    bookingsPlacedActive.length !== 0) ||
                  (placedView == 'all' && bookingsPlacedActive.length !== 0)
                "
              >
                <v-col cols="12">
                  <v-row class="my-4">
                    <h3>Active bookings</h3>
                  </v-row>
                </v-col>

                <v-col
                  cols="12"
                  sm="6"
                  lg="3"
                  v-for="booking in bookingsPlacedActive"
                  :key="booking.id"
                >
                  <v-card
                    style="border-radius: 12px"
                    class="ma-2"
                    color="lgrey"
                    elevation="4"
                    :to="'/booking' + '/' + booking.id"
                  >
                    <v-row class="card-head">
                      <v-col style="padding: 8px; padding-left: 16px" cols="10">
                        <h4>
                          <span class="white--text">Active Rental</span>
                        </h4>
                      </v-col>
                      <v-col class="center" style="margin: 0px" cols="2">
                        <v-icon
                          @click.prevent="
                            showToast(
                              'You are currently renting this item from ' +
                                booking.lenderName +
                                '.'
                            )
                          "
                          style="color: white; float: right; align-self: right"
                          small
                          class="mr-1"
                          >fas fa-info-circle</v-icon
                        >
                      </v-col>
                    </v-row>
                    <v-col cols="12 pa-6">
                      <v-row>
                        <v-col cols="6">
                          <v-card
                            height="125px"
                            width="125px"
                            class="card ma-3"
                            style="border-radius: 12px"
                          >
                            <v-img
                              :src="booking.images ? booking.images[0] : ''"
                              height="125px"
                              width="125px"
                            />
                          </v-card>
                        </v-col>
                        <v-col cols="6">
                          <div
                            class="ma-3 mt-md-4 mt-1 mt-sm-2 my-auto text-caption text-sm-body-2"
                          >
                            <div
                              class="ml-n3 my-1 my-md-4 black--text clip-booking"
                            >
                              <span class="font-weight-bold">{{
                                booking.itemName
                              }}</span>
                            </div>

                            <div class="ml-n3 my-1 my-md-4 my-2 clip-booking">
                              <span class="font-weight-bold clip-booking">
                                {{ booking.startDate }} -
                                {{ booking.endDate }}</span
                              >
                            </div>
                            <!-- <div class="ml-n3 my-1 my-md-4 my-2">
                              Length:
                              <span class="font-weight-bold">
                                {{ booking.dateRange }} days</span
                              >
                            </div> -->
                            <div class="ml-n3 my-1 my-md-4 my-2 borrowername">
                              Total:
                              <span class="font-weight-bold">
                                R{{ booking.total }}</span
                              >
                            </div>
                            <div
                              class="ml-n3 my-1 my-md-4 my-2 borrowername"
                              style="cursor: pointer"
                            >
                              <v-avatar
                                v-if="booking.lenderAvatar"
                                outline
                                size="25"
                                class="mr-1 mt-n2"
                                style="margin-bottom: -3px"
                              >
                                <v-img :src="booking.lenderAvatar"></v-img>
                              </v-avatar>
                              <svg
                                v-else-if="!booking.lenderAvatar"
                                viewBox="0 0 32 32"
                                class="mr-1"
                                xmlns="http://www.w3.org/2000/svg"
                                :style="
                                  $vuetify.breakpoint.xsOnly
                                    ? 'height: 15px; width: 15px;'
                                    : '' && $vuetify.breakpoint.smAndDown
                                    ? 'height: 20px; width: 20px;'
                                    : 'height: 20px; width: 20px;' &&
                                      $vuetify.breakpoint.mdAndUp
                                    ? 'height: 20px; width: 20px;'
                                    : 'height: 20px; width: 20px;'
                                "
                                style="fill: currentcolor; margin-bottom: -3px"
                                aria-label="Profile button"
                                role="presentation"
                                focusable="false"
                              >
                                <path
                                  d="m16 .7c-8.437 0-15.3 6.863-15.3 15.3s6.863 15.3 15.3 15.3 15.3-6.863 15.3-15.3-6.863-15.3-15.3-15.3zm0 28c-4.021 0-7.605-1.884-9.933-4.81a12.425 12.425 0 0 1 6.451-4.4 6.507 6.507 0 0 1 -3.018-5.49c0-3.584 2.916-6.5 6.5-6.5s6.5 2.916 6.5 6.5a6.513 6.513 0 0 1 -3.019 5.491 12.42 12.42 0 0 1 6.452 4.4c-2.328 2.925-5.912 4.809-9.933 4.809z"
                                ></path>
                              </svg>
                              <span
                                class="font-weight-bold borrowername text-subtitle-1"
                              >
                                {{ booking.lenderName }}
                              </span>
                            </div>
                          </div>
                        </v-col>
                      </v-row>
                      <v-row class="grid"
                        ><v-btn
                          rounded
                          :to="'/booking' + '/' + booking.id"
                          class="hidden mx-1 white app--text font-weight-medium"
                          z-index="12"
                        >
                          <u>View Booking</u>
                          <v-icon
                            style="
                              margin-left: 8px;
                              float: right;
                              align-self: right;
                            "
                            x-small
                            class="mr-1"
                          >
                            fas fa-chevron-right</v-icon
                          >
                        </v-btn></v-row
                      >
                    </v-col>
                  </v-card>
                </v-col>
              </v-row>

              <v-row
                v-if="placedView == 'all' && bookingsPlacedOverdue.length !== 0"
              >
                <v-col
                  cols="12"
                  sm="6"
                  lg="3"
                  v-for="booking in bookingsPlacedOverdue"
                  :key="booking.id"
                >
                  <v-col cols="12">
                    <v-row class="my-4">
                      <h3>Overdue bookings {{}}</h3>
                    </v-row>
                  </v-col>
                  <v-card
                    style="border-radius: 12px"
                    class="ma-2"
                    color="lgrey"
                    elevation="4"
                    :to="'/booking' + '/' + booking.id"
                  >
                    <v-row class="card-head">
                      <v-col style="padding: 8px; padding-left: 16px" cols="10">
                        <h4>
                          <span class="white--text">Overdue booking with </span>

                          <span class="white--text" style="cursor: pointer"
                            ><u>{{ booking.lenderName }}</u></span
                          >
                        </h4>
                      </v-col>
                      <v-col class="center" style="margin: 0px" cols="2">
                        <v-icon
                          @click.prevent="
                            showToast(
                              'Your rental with ' +
                                booking.lenderName +
                                ' has ended. Please return their item.'
                            )
                          "
                          style="color: white; float: right; align-self: right"
                          small
                          class="mr-1"
                          >fas fa-info-circle</v-icon
                        >
                      </v-col>
                    </v-row>
                    <v-col cols="12 pa-6">
                      <v-row>
                        <v-col cols="6">
                          <v-card
                            height="125px"
                            width="125px"
                            class="card ma-3"
                            style="border-radius: 12px"
                          >
                            <v-img
                              :src="booking.images ? booking.images[0] : ''"
                              height="125px"
                              width="125px"
                            />
                          </v-card>
                        </v-col>
                        <v-col cols="6">
                          <div
                            class="ma-3 mt-md-4 mt-1 mt-sm-2 my-auto text-caption text-sm-body-2"
                          >
                            <div
                              class="ml-n3 my-1 my-md-4 black--text clip-booking"
                            >
                              <span class="font-weight-bold clip-booking">{{
                                booking.itemName
                              }}</span>
                            </div>

                            <div class="ml-n3 my-1 my-md-4 my-2 clip-booking">
                              <span class="font-weight-bold clip-booking">
                                {{ booking.startDate }} -
                                {{ booking.endDate }}</span
                              >
                            </div>
                            <!-- <div class="ml-n3 my-1 my-md-4 my-2">
                              Length:
                              <span class="font-weight-bold">
                                {{ booking.dateRange }} days</span
                              >
                            </div> -->
                            <div class="ml-n3 my-1 my-md-4 my-2 borrowername">
                              Total:
                              <span class="font-weight-bold">
                                R{{ booking.total }}</span
                              >
                            </div>

                            <div
                              class="ml-n3 my-1 my-md-4 my-2 borrowername"
                              style="cursor: pointer"
                            >
                              <v-avatar
                                v-if="booking.lenderAvatar"
                                outline
                                size="25"
                                class="mr-1 mt-n2"
                                style="margin-bottom: -3px"
                              >
                                <v-img :src="booking.lenderAvatar"></v-img>
                              </v-avatar>
                              <svg
                                v-else-if="!booking.lenderAvatar"
                                viewBox="0 0 32 32"
                                class="mr-1"
                                xmlns="http://www.w3.org/2000/svg"
                                :style="
                                  $vuetify.breakpoint.xsOnly
                                    ? 'height: 15px; width: 15px;'
                                    : '' && $vuetify.breakpoint.smAndDown
                                    ? 'height: 20px; width: 20px;'
                                    : 'height: 20px; width: 20px;' &&
                                      $vuetify.breakpoint.mdAndUp
                                    ? 'height: 20px; width: 20px;'
                                    : 'height: 20px; width: 20px;'
                                "
                                style="fill: currentcolor; margin-bottom: -3px"
                                aria-label="Profile button"
                                role="presentation"
                                focusable="false"
                              >
                                <path
                                  d="m16 .7c-8.437 0-15.3 6.863-15.3 15.3s6.863 15.3 15.3 15.3 15.3-6.863 15.3-15.3-6.863-15.3-15.3-15.3zm0 28c-4.021 0-7.605-1.884-9.933-4.81a12.425 12.425 0 0 1 6.451-4.4 6.507 6.507 0 0 1 -3.018-5.49c0-3.584 2.916-6.5 6.5-6.5s6.5 2.916 6.5 6.5a6.513 6.513 0 0 1 -3.019 5.491 12.42 12.42 0 0 1 6.452 4.4c-2.328 2.925-5.912 4.809-9.933 4.809z"
                                ></path>
                              </svg>
                              <span class="font-weight-bold text-subtitle-1">
                                {{ booking.lenderName }}
                              </span>
                            </div>
                          </div>
                        </v-col>
                      </v-row>
                      <v-row class="grid"
                        ><v-btn
                          rounded
                          :to="'/booking' + '/' + booking.id"
                          class="hidden mx-1 white app--text font-weight-medium"
                          z-index="12"
                        >
                          <u>View Booking</u>
                          <v-icon
                            style="
                              margin-left: 8px;
                              float: right;
                              align-self: right;
                            "
                            x-small
                            class="mr-1"
                          >
                            fas fa-chevron-right</v-icon
                          >
                        </v-btn></v-row
                      >
                    </v-col>
                  </v-card>
                </v-col>
              </v-row>

              <v-row
                v-if="placedView == 'all' && bookingsPlacedOverdue.length !== 0"
              >
                <v-col
                  cols="12"
                  sm="6"
                  lg="3"
                  v-for="booking in bookingsPlacedDeclined"
                  :key="booking.id"
                >
                  <v-card
                    style="border-radius: 12px"
                    class="ma-2"
                    color="lgrey"
                    elevation="4"
                    :to="'/booking' + '/' + booking.id"
                  >
                    <v-row class="card-head">
                      <v-col style="padding: 8px; padding-left: 16px" cols="10">
                        <h4>
                          <span class="white--text">Booking declined by </span>

                          <span class="white--text" style="cursor: pointer"
                            ><u>{{ booking.lenderName }}</u></span
                          >
                        </h4>
                      </v-col>
                      <v-col class="center" style="margin: 0px" cols="2">
                        <v-icon
                          @click.prevent="
                            showToast(
                              'We regret to inform you that ' +
                                booking.lenderName +
                                ' has declined your booking request.'
                            )
                          "
                          style="color: white; float: right; align-self: right"
                          small
                          class="mr-1"
                          >fas fa-info-circle</v-icon
                        >
                      </v-col>
                    </v-row>
                    <v-col cols="12 pa-6">
                      <v-row>
                        <v-col cols="6">
                          <v-card
                            height="125px"
                            width="125px"
                            class="card ma-3"
                            style="border-radius: 12px"
                          >
                            <v-img
                              :src="booking.images ? booking.images[0] : ''"
                              height="125px"
                              width="125px"
                            />
                          </v-card>
                        </v-col>
                        <v-col cols="6">
                          <div
                            class="ma-3 mt-md-4 mt-1 mt-sm-2 my-auto text-caption text-sm-body-2"
                          >
                            <div
                              class="ml-n3 my-1 my-md-4 black--text clip-booking"
                            >
                              <span class="font-weight-bold clip-booking">{{
                                booking.itemName
                              }}</span>
                            </div>

                            <div class="ml-n3 my-1 my-md-4 my-2 clip-booking">
                              <span class="font-weight-bold clip-booking">
                                {{ booking.startDate }} -
                                {{ booking.endDate }}</span
                              >
                            </div>
                            <!-- <div class="ml-n3 my-1 my-md-4 my-2">
                              Length:
                              <span class="font-weight-bold">
                                {{ booking.dateRange }} days</span
                              >
                            </div> -->
                            <div class="ml-n3 my-1 my-md-4 my-2 borrowername">
                              Total:
                              <span class="font-weight-bold">
                                R{{ booking.total }}</span
                              >
                            </div>

                            <div
                              class="ml-n3 my-1 my-md-4 my-2 borrowername"
                              style="cursor: pointer"
                            >
                              <v-avatar
                                v-if="booking.lenderAvatar"
                                outline
                                size="25"
                                class="mr-1 mt-n2"
                                style="margin-bottom: -3px"
                              >
                                <v-img :src="booking.lenderAvatar"></v-img>
                              </v-avatar>
                              <svg
                                v-else-if="!booking.lenderAvatar"
                                viewBox="0 0 32 32"
                                class="mr-1"
                                xmlns="http://www.w3.org/2000/svg"
                                :style="
                                  $vuetify.breakpoint.xsOnly
                                    ? 'height: 15px; width: 15px;'
                                    : '' && $vuetify.breakpoint.smAndDown
                                    ? 'height: 20px; width: 20px;'
                                    : 'height: 20px; width: 20px;' &&
                                      $vuetify.breakpoint.mdAndUp
                                    ? 'height: 20px; width: 20px;'
                                    : 'height: 20px; width: 20px;'
                                "
                                style="fill: currentcolor; margin-bottom: -3px"
                                aria-label="Profile button"
                                role="presentation"
                                focusable="false"
                              >
                                <path
                                  d="m16 .7c-8.437 0-15.3 6.863-15.3 15.3s6.863 15.3 15.3 15.3 15.3-6.863 15.3-15.3-6.863-15.3-15.3-15.3zm0 28c-4.021 0-7.605-1.884-9.933-4.81a12.425 12.425 0 0 1 6.451-4.4 6.507 6.507 0 0 1 -3.018-5.49c0-3.584 2.916-6.5 6.5-6.5s6.5 2.916 6.5 6.5a6.513 6.513 0 0 1 -3.019 5.491 12.42 12.42 0 0 1 6.452 4.4c-2.328 2.925-5.912 4.809-9.933 4.809z"
                                ></path>
                              </svg>
                              <span class="font-weight-bold text-subtitle-1">
                                {{ booking.lenderName }}
                              </span>
                            </div>
                          </div>
                        </v-col>
                      </v-row>
                      <v-row class="grid"
                        ><v-btn
                          rounded
                          :to="'/booking' + '/' + booking.id"
                          class="hidden mx-1 white app--text font-weight-medium"
                          z-index="12"
                        >
                          <u>View Booking</u>
                          <v-icon
                            style="
                              margin-left: 8px;
                              float: right;
                              align-self: right;
                            "
                            x-small
                            class="mr-1"
                          >
                            fas fa-chevron-right</v-icon
                          >
                        </v-btn></v-row
                      >
                    </v-col>
                  </v-card>
                </v-col>
              </v-row>

              <!-- COMPLETED BOKINGS PLACED -->

              <v-col cols="12">
                <v-row class="my-4">
                  <h3
                    v-if="
                      bookingsPlacedReturned.length > 0 ||
                      bookingsPlacedCompleted.length > 0 ||
                      bookingsPlacedCancelled.length > 0
                    "
                  >
                    Past bookings
                  </h3>
                </v-row>
              </v-col>

              <template>
                <v-col
                  cols="12"
                  sm="6"
                  lg="3"
                  v-for="booking in bookingsPlacedReturned"
                  :key="booking.id"
                  style="padding: 0px !important"
                >
                  <v-card
                    style="border-radius: 12px"
                    class="pa-6 ma-2"
                    color="lgrey"
                    elevation="4"
                  >
                    <v-row>
                      <v-col cols="12">
                        <v-row class="mx-1" style="text-align: left">
                          <h4>
                            <span class="black--text">Returned Booking</span>
                          </h4>
                        </v-row>
                        <br />
                        <!-- <p class="clip-booking">{{ booking.itemName }}</p> -->
                        <v-row>
                          <!-- <v-col style="text-align: left" cols="5">
                          {{ booking.endDate }}
                        </v-col> -->
                          <!-- <v-col
                          style="text-align: right; padding-left: 0px"
                          cols="7"
                        >
                          R{{ booking.rentalFee }}.00 ({{ booking.dateRange }}
                          Day/s)
                        </v-col> -->
                        </v-row>
                        <!-- <rating-item-dialog
                        style="margin-bottom: 16px"
                        :booking="booking"
                        :showBtn="true"
                        :open="false"
                      >
                      </rating-item-dialog> -->
                      </v-col>
                    </v-row>
                    <v-row class="grid"
                      ><v-btn
                        rounded
                        :to="'/booking' + '/' + booking.id"
                        class="hidden mx-1 white app--text font-weight-medium"
                        z-index="12"
                      >
                        <u>View Booking</u>
                        <v-icon
                          style="
                            margin-left: 8px;
                            float: right;
                            align-self: right;
                          "
                          x-small
                          class="mr-1"
                        >
                          fas fa-chevron-right</v-icon
                        >
                      </v-btn></v-row
                    >
                  </v-card>
                </v-col>

                <v-col
                  cols="12"
                  md="6"
                  lg="3"
                  v-for="booking in bookingsPlacedCompleted"
                  :key="booking.id"
                  style="padding: 0px !important"
                >
                  <v-card
                    style="border-radius: 12px"
                    class="pa-6 ma-2"
                    color="lgrey"
                    elevation="4"
                    :to="'/booking' + '/' + booking.id"
                  >
                    <v-row>
                      <v-col cols="12">
                        <v-row class="mx-1" style="text-align: left">
                          <h4>
                            <span class="black--text">Completed Booking</span>
                          </h4>
                        </v-row>

                        <br />
                        <p class="clip-booking">{{ booking.itemName }}</p>

                        <v-row>
                          <v-col style="text-align: left" cols="5">
                            {{ booking.endDate }}
                          </v-col>
                          <v-col
                            style="text-align: right; padding-left: 0px"
                            cols="7"
                          >
                            R{{ booking.rentalFee }}.00 ({{ booking.dateRange }}
                            Day/s)
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                    <v-row class="grid"
                      ><v-btn
                        rounded
                        :to="'/booking' + '/' + booking.id"
                        class="hidden mx-1 white app--text font-weight-medium"
                        z-index="12"
                      >
                        <u>View Booking</u>
                        <v-icon
                          style="
                            margin-left: 8px;
                            float: right;
                            align-self: right;
                          "
                          x-small
                          class="mr-1"
                        >
                          fas fa-chevron-right</v-icon
                        >
                      </v-btn></v-row
                    >
                  </v-card>
                </v-col>

                <v-col
                  cols="12"
                  sm="6"
                  lg="3"
                  v-for="booking in bookingsPlacedCancelled"
                  :key="booking.id"
                  style="padding: 0px !important"
                >
                  <v-card
                    style="border-radius: 12px"
                    class="pa-6 ma-2"
                    color="lgrey"
                    elevation="4"
                  >
                    <v-row>
                      <v-col cols="12">
                        <v-row class="mx-1" style="text-align: left">
                          <h4>
                            <span class="black--text">Cancelled Booking</span>
                          </h4>
                        </v-row>

                        <br />
                        <p class="clip-booking">{{ booking.itemName }}</p>

                        <v-row>
                          <v-col style="text-align: left" cols="5">
                            {{ booking.endDate }}
                          </v-col>
                          <v-col
                            style="text-align: right; padding-left: 0px"
                            cols="7"
                          >
                            R{{ booking.rentalFee }}.00 ({{ booking.dateRange }}
                            Day/s)
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                    <v-row class="grid"
                      ><v-btn
                        rounded
                        :to="'/booking' + '/' + booking.id"
                        class="hidden mx-1 white app--text font-weight-medium"
                        z-index="12"
                      >
                        <u>View Booking</u>
                        <v-icon
                          style="
                            margin-left: 8px;
                            float: right;
                            align-self: right;
                          "
                          x-small
                          class="mr-1"
                        >
                          fas fa-chevron-right</v-icon
                        >
                      </v-btn></v-row
                    >
                  </v-card>
                </v-col>
              </template>
            </v-row>
          </v-col>
        </template>

        <!-- REVIEWS -->
      </v-col>
    </v-row>

    <!-- REVIEW success -->
    <v-dialog
      v-if="reviewSubmitted"
      v-model="reviewSubmitted"
      persistent
      color="white"
      style="border-radius: 12px !important; overflow: hidden"
      width="550"
    >
      <v-card
        style="border-radius: 12px !important; overflow: hidden"
        class="pa-3 text-center"
      >
        <v-card-title
          style="
            padding: 0px 24px !important;
            font-size: 1em !important;
            line-height: 1.43;
          "
          class="text-center black--text"
        >
          <v-icon small color="black" @click="endReview()">mdi-close</v-icon>
          <p class="my-3 ml-auto mr-auto">Review Submitted! 🥳</p>
        </v-card-title>
        <v-divider></v-divider>
        <v-row>
          <v-col cols="12">
            <p class="pa-6">
              <span class="text-subtitle-2 font-weight-bold"
                >Thank you for participating in the Strapp Community</span
              >
              <br /><br />
              We hope to continue providing you with the best service we can.
            </p>
          </v-col>
        </v-row>
        <div class="grid mt-n3">
          <v-btn class="appbutton mt-n3" @click="endReview()">Continue</v-btn>
        </div>
      </v-card>
    </v-dialog>

    <!-- USER RATING DIALOG -->

    <div v-if="!loading && returned.length >= 1">
      <div v-if="bookingsReceivedReturned.length >= 1">
        <rating-dialog
          :booking="bookingsReceivedReturned[0]"
          :showBtn="false"
          :open="true"
        />
      </div>
    </div>

    <!-- ITEM RATING DIALOG -->
    <div v-if="returned.length >= 1">
      <div v-if="bookingsPlacedReturned.length >= 1">
        <rating-item-dash-pop
          style="margin-bottom: 16px"
          :booking="bookingsPlacedReturned[0]"
          :showBtn="false"
          :open="true"
        >
        </rating-item-dash-pop>
      </div>
    </div>
    <!-- We really appreciate your feedback we will use it to improve our
              platform to better service you. We hope to get you amazing rental
              experiences in the future. -->
    <!-- END USER REVIEW -->

    <v-snackbar v-model="snackbar">
      {{ text }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="pink"
          text
          v-bind="attrs"
          @click.prevent="snackbar = false"
        >
          Got it!
        </v-btn>
      </template>
    </v-snackbar>

    <v-btn
      v-scroll="onScroll"
      v-show="fab"
      fab
      dark
      fixed
      bottom
      right
      style="margin: 20px"
      color="primary"
      @click.prevent="toTop"
    >
      <v-icon>fas fa-angle-up</v-icon>
    </v-btn>
  </div>
</template>

<style scoped>
.selected {
  border-bottom: 5px solid rgb(178, 42, 240);
  background-color: lavender;
}

.borrowername {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  font-size: 0.875rem !important;
}
.borrowername:hover {
  color: #b22af0 !important;
}

.rounded {
  border-radius: 12px;
}

.grid {
  display: grid;
  place-items: center;
}

.Fixed {
  position: fixed;
  top: 20px;
}

.item {
  cursor: pointer;
}

.itmcrd {
  transition: opacity 0s ease-in-out;
}

.itmcrd:hover {
  opacity: 0.8;
}

.card-head {
  background-color: #b22af0;
  width: 100%;
  padding: 16px;
  margin: 0px !important;
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.clip {
  text-overflow: clip;
  white-space: nowrap;
  width: 190px;
  overflow: hidden;
}

.clip-booking {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  font-size: 0.875rem !important;
}

.card {
  border-color: rgb(221, 221, 221);
}

.card:hover {
  border-color: rgb(34, 34, 34);
}

.ebtn {
  display: inline-block;
  background: #7fc4a1;
  padding: 0.8rem 1.8rem;
  width: 25px;
  margin-top: 2rem;
  cursor: pointer;
  border-radius: 14px;
  font-weight: 700;
  transition: 0.5s;
  box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease 0s;
}

.ebtn:hover {
  opacity: 0.8;
  border-radius: 18px;
  box-shadow: 0px 15px 20px rgba(46, 229, 157, 0.4);
  transform: translateY(-7px);
  color: #7552b9;
  background-color: #7552b9;
}

.add-button {
  padding: 1rem 4rem;
  border-radius: 100rem;
  font-weight: 700;
  transition: 0.5s;
  box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease 0s;
}

.add-button:hover {
  box-shadow: 0px 15px 20px rgba(46, 229, 157, 0.4);
  transform: translateY(-7px);
}

.vbutton {
  padding: 1rem 4rem;
  border-radius: 100rem;
  font-weight: 700;
  transition: 0.5s;
  box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease 0s;
  width: 12rem;
}

.vbutton:hover {
  color: #7552b9;
  background-color: #7552b9;
  box-shadow: 0px 15px 20px rgba(46, 229, 157, 0.4);
  transform: translateY(-7px);
  width: 13rem;
}

.hidden {
  border-style: none;
  box-shadow: none;
  background-color: #f7f7f7 !important;
}

.center {
  display: grid;
  place-items: center;
}

@import url("https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css");
</style>
